webpackJsonp([1],{

/***/ "6ztS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Fv8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "89bq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bhpb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JFPs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b688dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("fNxP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-013d71fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("bQQb")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ce7210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("JFPs")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-69ce7210"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5864a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("Du5H")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-7ba5864a"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eed32ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}),0)]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("89bq")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9eed32ec"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94907be2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("QRRU")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ad378a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}),0)])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Zhdp")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2470dd02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}),0)])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("Bhpb")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f0bddd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("f34v")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8e3a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("mp9z")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfd056f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("gUQz")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01cda1e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){return _vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()}),0):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("Q4jA")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e57029e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}),1)])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("6ztS")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39079333","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){return _vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])}),0),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("be29")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c984c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return null}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205d0721","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}),0)}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("UR7i")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3e62da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("m1X4")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26fd9192","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}),0)],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("WI9Y")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-26fd9192"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ee35ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("7Fv8")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6de9100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("gkoj")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a43979","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("R3wh")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "IOC Marketing Report Tokyo 2020",
  "shortTitle": "",
  "description": "",
  "width": 645,
  "height": 912,
  "currentLanguage": "EN",
  "languages": [],
  // "basePath": "",
  "basePath": "/tokyo2020",
  "companyLogo": "1-logo.png",
  "publishURL": "http://iocmarketingreport.touchlines.com/tokyo2020/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": false,
    "mobileSwitch": false
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "International Olympic Committee  IOC MARKETING REPORT TOKYO 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/luJGosl3CxQ')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:538px;top:104px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(4)\" style=\"top:237px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(10)\" style=\"top:264px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(20)\" style=\"top:290px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(26)\" style=\"top:315px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(38)\" style=\"top:341px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(76)\" style=\"top:368px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(92)\" style=\"top:394px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(98)\" style=\"top:419px;left:198px;width:410px;height:25px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(108)\" style=\"top:446px;left:198px;width:410px;height:25px\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Contents  3  CONTENTS Forewords  04  United by Emotion  10  Olympic Marketing Overview  20  Olympic Broadcasting  26  Olympic Partnerships  38  Fan Engagement  76  Licensing and Merchandising  92  The Olympic Brand  98  Acknowledgements  108"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“For the first time since the pandemic began, the entire world was able to come together. Sport returned to centre stage. Billions of people around the globe were united by emotion, sharing moments of joy and inspiration.” Thomas Bach, President, International Olympic Committee"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "5  FOREWORD BY THOMAS BACh T  hroughout the Olympic Games Tokyo 2020, more than 11,000 athletes amazed us with their sporting achievements. With their excellence, with their emotions and with their spirit, they created magic moments for everyone to share and enjoy.  Movement and sports fans around the world owe them our immense gratitude. These were unprecedented Olympic Games. It took an equally unprecedented effort from the Olympic Movement and our Japanese partners and friends to make them happen.  And while competing fiercely with each other for Olympic glory, these athletes from every corner of the world also sent a powerful message of solidarity, peace and the unifying power of sport. They were faster, they went higher and they were stronger, because we all stood together.  Our thanks and appreciation go to the Japanese authorities, the Organising Committee and the entire Olympic community for the great solidarity that everyone demonstrated to host these Games for the athletes, who were longing for their moment to shine. Our warm thanks also go to the National Olympic Committees, the International Federations, our TOP Partners, sponsors and Rights-Holding Broadcasters for their truly outstanding show of unity and support.  In these difficult times, these athletes gave everyone the precious gift of hope. For the first time since the pandemic began, the entire world was able to come together. Sport returned to centre stage. Billions of people around the globe were united by emotion, sharing moments of joy and inspiration. These moments were only possible because of the stage that Japan prepared for the athletes. The Japanese people can be extremely proud of what they achieved in the face of all the challenges, and the entire Olympic  Looking back, we can say that we did it like athletes and for the athletes. We did it – together.  Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“The Games also reached new heights off the field of play, with historic broadcast ratings, unprecedented digital engagement and innovative marketing campaigns all helping to bring the world together like never before for an Olympic Games.” Jiří Kejval, Chair IOC Marketing Commission"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "7  FOREWORD BY Jiří Kejval T  he Olympic Games Tokyo 2020 saw outstanding performances on the field by athletes from all over the world, with more National Olympic Committees (NOCs) winning medals than ever before. But the record-breaking performances were not only limited to Tokyo’s Olympic venues. The Games also reached new heights off the field of play, with historic broadcast ratings, unprecedented digital engagement and innovative marketing campaigns all helping to bring the world together like never before for an Olympic Games. Thanks to Olympic Broadcasting Services and our Rights-Holding Broadcasters, fans were able to enjoy Tokyo 2020 content on more screens than ever through TV, digital platforms, apps and social media. The huge global interest in the Games was typified within the host nation of Japan, where nine in 10 people watched some coverage of Tokyo 2020. This incredible level of engagement was seen throughout the world, with our broadcast partners enjoying a much higher share of viewing than their typical average and their streaming platforms in particular experiencing record numbers of views.  By sharing the magic of the Olympic Games with people around the world, our broadcast partners played an indispensable role in uniting the globe in the spirit and emotion of Tokyo 2020 and, with fans unable to attend these Games, their role was more important than ever. Similarly, the great success of Tokyo 2020 would not have been possible without the enduring support of our Worldwide Olympic Partners, whose expertise, people, services, products, technology and financing are essential to staging each edition of the Olympic Games. This Marketing Report aims to highlight the incredible efforts of these global partners as well as the record-breaking results of our broadcast partners and other marketing programmes, which are vital to the entire Olympic Movement. By redistributing 90 per cent of the revenues we generate through these programmes, the IOC is able to support sport and athletes globally, all year round, meaning more athletes from more NOCs are able to achieve their dreams, just as those in Tokyo did.  Jiří Kejval, Chair, IOC Marketing Commission"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“The Olympic flame that lit up Tokyo has gone out. But the hope that was ignited here will never be extinguished.” Hashimoto Seiko, President, Tokyo 2020 Organising Committee"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "9  FOREWORD BY Hashimoto Seiko F  irst, I would like to express sincere thanks and gratitude to all participants in the Olympic Games Tokyo 2020. We have seen a true spirit of solidarity among all those involved in making these Games happen. In particular, I must express my deep gratitude to all those in medical services for their immense contributions to the safety and security of the Games. I would also like thank the many volunteers who supported the Games. The Tokyo 2020 Games are a testament to their strength, their power and their love for sport. Although many of the events were held without spectators, the athletes were greeted instead by arrangements of flowers grown by schoolchildren across Japan. The vines were intertwined and resilient, as if depicting the unity of the people of the world. There are no words to describe what athletes have achieved in Tokyo. Through hard work and perseverance, they overcame unbelievable challenges to become true Olympians. One athlete’s jubilant victory is another’s bitter defeat. Yet, in the space of an instant, winner and loser come together in the same feeling of acknowledgement and respect. This is  the beauty of the Olympic Games and the value of the Olympic spirit. The Olympic flame that lit up Tokyo has gone out. But the hope that was ignited here will never be extinguished. It will remain alight in the hearts of people all over the world as we continue to hope for peace in the spirit of Ekecheiria, a tradition unbroken from the ancient Olympic Games. “Sport has the power to change the world and our future.” This power, I believe, will carry us through to future Games. Finally, I would like to thank President Bach and all the members of the IOC, the Government of Japan, the Tokyo Metropolitan Government, and everyone else who has supported these Games. Athletes and people of the world, we hope to welcome you here again someday. Thank you very much for being a part of these Games.  Hashimoto Seiko, President, Tokyo 2020 Organising Committee"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/6ukU4Ym0vEE')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:10px;top:251px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "United by Emotion"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/8pzFZqUVjb4')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:30px;top:75px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "12  United by Emotion During more than two weeks of thrilling competition full of drama, excitement, passion and inspiration, the Olympic Games Tokyo 2020 more than lived up to their motto, as athletes from every corner of the globe – and billions of fans watching around the world – were United by Emotion. From the moment Japanese tennis star Naomi Osaka lit the cauldron to signal the start of the Games, more than 11,000 athletes from 205 National Olympic Committees and the IOC Refugee  Olympic Team grasped their moment to shine following a one-year delay due to the COVID-19 pandemic, as they came together to compete in the Olympic spirit. And that inimitable spirit was evident throughout the Games. There were the impressive medal collections of archer An San, sprint canoeist Lisa Carrington, sprinter Elaine Thompson-Herah and swimmers Emma McKeon, Caeleb Dressel and Kaylee McKeown.  Athletes happy to have chance to compete at Tokyo 2020 In a post-Games survey conducted with the athletes, it was clearly demonstrated that participation in the Olympic Games Tokyo 2020 was important to them. Regarding their motivation to compete, 93 per cent of athletes stated that it was important “to compete at the biggest multi-sports event on earth”, and 84 per cent rated it important “to become an Olympian”."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  United by Emotion  13  tOkyo in numbers  339  “The Olympic Games Tokyo 2020 are the Olympic Games of hope, solidarity and peace.”  events  Thomas Bach, IOC President  “We were finally able to create a single stage where athletes from all over the world could gather. What I saw every day was a bond between people, a harmony in diversity, a symbol of peace and the power of sport itself.”  33  sports  11,259  Hashimoto Seiko, Tokyo 2020 President  athlete entries  52% male  48% female  205  National Olympic Committees + the IOC Refugee Olympic Team"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“Thank you for putting on wonderful Games. I know it was tough, but we appreciate everything you did.” Tia-Adana Belle (Barbados, athletics)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/4zuA6CoGcMA')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:50px;top:49px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/oR7OnwwB1fo')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:341px;top:553px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  United by Emotion  15  More NOCs winning medals than ever before  3 NOCs won their first Olympic medal  3 NOCs won their first Olympic gold medal  BERMUDA (Flora Duffy, triathlon)  BURKINA FASO (Hugues Fabrice Zango, athletics)  TURKMENISTAN (Polina Guryeva, weightlifting)  SAN MARINO (Alessandra Perilli, shooting)  93 NOCs won medals  PHILIPPINES (Hidilyn Diaz, weightlifting)  QATAR (Fares Ibrahim, weightlifting)  There were the host nation heroics by Japan’s athletes, who helped the country enjoy its most successful Games ever. There were the record-breaking feats of athletes at the peak of their powers, such as triple jumper Yulimar Rojas, swimmer Tatjana Schoenmaker and hurdlers Karsten Warholm and Sydney McLaughlin. There were the inspirational performances of 29 refugee athletes, who overcame unimaginable hardships to reach the Olympic Games. There were the tears of joy from Tom Daley, Owen Wright, Greysia Polii, Apriyani Rahayu and many others as they became  “True to the name of the Tokyo 2020 slogan, ‘United By Emotion’, there has been plenty of emotion in the inspirational sporting triumphs.” Walter Sim, The Straits Times"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "16  Olympic medals 339 medal events Most decorated athlete  1,080  340  338  402  podium places  Gold*  Silver*  Bronze*  Most golds: 5  Caeleb Dressel  Youngest medallist: 12  Hiraki Kokona  (USA, swimming)  (JPN, skateboarding)  Oldest medallist: 62  First woman to compete in nine Olympic Games  Andrew Hoy  Nino Salukvadze  Emma McKeon (AUS, swimming) 4 gold, 3 bronze Second woman to win seven medals in a single Games *Two gold medals were awarded in the men’s high jump athletics event. No silver medal was awarded. Two bronze medals were awarded in each event in boxing, judo, karate, taekwondo, and wrestling. Two bronze medals were awarded for a third-place tie in the women’s floor gymnastics event.  “Japan has done an amazing job and we must thank them so much for all the hard work and support. They managed to unite us as one to be here and compete. It’s taken our minds away from the pandemic that we’re living in.” Valerie Adams (New Zealand, athletics)  (AUS, equestrian)  (GEO, shooting)  overwhelmed by their achievements on sport’s greatest stage.  Fares Ibrahim, who each captured their countries’ first Olympic golds.  There was the youthful exuberance of skateboarders such as Momiji Nishiya, Rayssa Leal and Sky Brown, as their sport made its Olympic debut alongside karate, sport climbing, surfing and the return of baseball/softball.  There was the courage shown by Simone Biles, who put the spotlight on athlete mental health when she withdrew from competition, and then bravely returned to win a bronze medal just a week later.  There were the historic successes of Hugues Fabrice Zango, Polina Guryeva and Alessandra Perilli, who won their countries’ first-ever Olympic medals, and those of Flora Duffy, Hidilyn Diaz and  There was the sportsmanship of high jumpers Gianmarco Tamberi and Mutaz Barshim, as the two friends chose to share the gold medal in one of the most memorable moments of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/oR7OnwwB1fo')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:40px;top:33px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/NjIU8lSNTy4')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:516px;top:513px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18  And throughout every venue, there were thousands of grateful athletes who were thankful that they finally had the opportunity to realise their Olympic dreams. “This summer, we were finally able to create a single stage where athletes from all over the world could gather,” said Tokyo 2020 President Hashimoto Seiko. “What I saw every day was a bond between people, a harmony in diversity, a symbol of peace and the power of sport itself.”  “Day after day over two weeks, the magic of Olympic competition cut through the gloom and isolation of the pandemic.” Simon Denyer and Michelle Ye Hee Lee, The Washington Post"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/MVnX-ENMh1I')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:27px;top:113px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  United by Emotion  19  Olympic solidarity 836  Olympic Solidarity scholarship-holders competed in Tokyo  29  teams supported by Olympic Solidarity Team Support Grants  USD 47 million  in Olympic Solidarity Scholarships for Athletes for Tokyo 2020  Supporting 1,836 athletes from 186 NOCs to prepare for the Games...  Including 56  refugee athletes from 13 countries  27  gold  32  silver  42  bronze  1  gold  1  silver  3  bronze"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/O24bBF6mzhU')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:557px;top:524px\" src=\"/tokyo2020/static/_content/yellow-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "20  Olympic Marketing Overview Did you know…? The International Olympic Committee (IOC) is entirely privately funded and ever since the first modern Olympic Games in Athens in 1896 it has relied upon contributions from commercial partners in order to stage the Games and support the Olympic Movement. Today, the IOC generates revenue through several different commercial programmes, including the sale of broadcast rights and The Olympic Partner (TOP) worldwide sponsorship programme. The support of these commercial partners helps ensure the financial security of the entire Olympic Movement, with 90 per cent of all IOC revenue being redistributed to support not only the Olympic Games but also athletes and sports organisations around the world,  including National Olympic Committees (NOCs), International Federations (IFs) and Organising Committees for the Olympic Games (OCOGs). The success of the Olympic marketing programmes has also contributed significantly to the growth of the Olympic Movement, the Olympic Games and sport worldwide.  “Long-term partnerships are the backbone of our commercial programmes and they enable the financial security of the entire Olympic Movement.” Thomas Bach, IOC President  Every day the equivalent of over USD 3.4 million is distributed by the IOC to support athletes and sports organisations at all levels around the world Sponsorship in various forms has supported the Olympic Movement since the first modern Olympic Games in Athens in 1896 The Olympic Games London 1948 were the first to award broadcast rights"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Marketing Overview  21  Olympic Marketing Revenue The International Olympic Committee (IOC) is entirely privately funded and therefore operates Olympic marketing programmes to attract commercial partners, which are crucial to the continued success of the Olympic Games and the operations of every organisation within the Olympic Movement.  The Olympic Partner Programme  IOC Licensing Programme  Broadcast partnerships  Managed by the IOC  Domestic sponsorship  Ticketing  Licensing within the host country  Managed by Organising Committees, under direction of IOC  Organising Committees for each Olympic Games  10%  IFs to run and promote their sports globally  Where the money goes  90% Individual athletes and coaches, via Olympic Solidarity funding  NOCs to help them support their athletes at national and local levels  IOC activities to develop sport and operations of the IOC  Other Olympic Movement and sport organisations to promote worldwide development of sport"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/W1AT52V5-5c')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:271px;top:60px\" src=\"/tokyo2020/static/_content/black-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "22  What is the TOP Programme? The IOC created The Olympic Partner (TOP) Programme in 1985 to diversify the Games’ revenue base and establish long-term partnerships that would benefit the Olympic Movement. The programme provides the IOC with a substantial percentage of its total revenue.  THE OLYMPIC PARTNER PROGRAMME Includes partnerships with the IOC, all NOCs and OCOGs  Highest level of Olympic partnership  Founded in 1985  Exclusive global marketing rights in a designated product or service category  Long-term support with some partnerships in place through to 2032  TOP Partners provide Valuable financial resources to the Olympic family  Products, services, technology, expertise and staff deployment to support the staging of the Olympic Games  Direct support for the training and development of Olympic athletes and hopefuls around the world  Global marketing campaigns that promote the Games and the Olympic values, and build support for athletes  Activations to enhance the Olympic Games experience for spectators  Essential services for athletes participating in the Games"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/-1NAeOoximU')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:298px;top:38px\" src=\"/tokyo2020/static/_content/blue-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Marketing Overview  23  Protect and promote the equity that is inherent in the Olympic image and ideals  Control and limit the commercialisation of the Olympic Games  Ensure the independent financial stability of the Olympic Movement  Goals of Olympic Marketing  Generate revenue to be distributed throughout the entire Olympic Movement  Ensure that the Olympic Games can be experienced by the maximum number of people throughout the world via broadcast coverage  Enlist the support of Olympic marketing partners in the promotion of the Olympic values Assist in the worldwide promotion of Olympism"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "24  Olympic Broadcasting The IOC grants rights to television, radio, mobile and internet coverage to media companies around the world  This allows people all over the world to experience the magic of the Olympic Games  Olympic Broadcasting Services (OBS) was established in 2001 to serve as the permanent host broadcaster for the Olympic Games  Broadcast coverage of the Olympic Games has been the main driver of the: • funding of the Olympic Movement and the Olympic Games • growth in global popularity of the Olympic Games • global promotion of the Olympic Games and the Olympic values  90 per cent of the revenues generated by the IOC go straight back into sport and athlete development"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Marketing Overview  25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Broadcasting"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "28  Olympic Broadcasting “Beijing 2008 was perhaps the first digital Games, London 2012 was the first social media Games, and Tokyo 2020 is the first streaming Olympic Games.” Timo Lumme, Managing Director, IOC Television and Marketing Services  Tokyo 2020 proved to be a watershed moment in the history of Olympic broadcasting, with more content made available to fans throughout the world on more screens than ever before through TV, digital streaming, websites, apps and social media. This meant that, while spectators were not able to attend events in person, fans in Japan and around the world were still able to experience the emotion and excitement of the Games, with 3.05 billion viewers across the globe enjoying coverage from Tokyo. And their enjoyment was further enhanced by a raft of cutting-edge innovations that were presented by Olympic Broadcasting Services (OBS), which was responsible for producing all the broadcast coverage of the Games and providing the international television and radio signals to all the rights-holding broadcasters (RHBs) around the world.  Most watched Olympic Games on digital platforms While TV remains the dominant platform for Olympic broadcast consumption – with 21.3 billion hours of Tokyo 2020 coverage consumed via TV, equivalent to 93 per cent of all broadcast coverage from the Games – the huge growth of digital viewing continues. Tokyo 2020 saw a 74 per cent upsurge in digital unique viewers compared with the Olympic Games Rio 2016, with a 139 per cent increase in the number of video views on digital platforms. This helped make Tokyo 2020 the most watched Olympic Games ever on digital platforms, and highlighted how the changing media landscape made these the first ‘streaming Games’."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Broadcasting  29  The first streaming Games  28bn digital video views  GLOBAL ACCESS  MOST WATCHED  Global Tokyo 2020 coverage available to everyone with access to TV or the internet  Tokyo 2020 was the most watched Olympic Games ever on digital platforms  3.05 Billion unique people watched the Games  64%  of viewers watched Tokyo 2020 on both TV and digital platforms  23bn  hours consumed via TV and digital  93% of coverage consumed via TV  74%  increase in digital unique viewers compared with Rio 2016  139%  increase in digital video views compared with Rio 2016"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "30"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/opK92LajFM8')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:354px;top:790px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Broadcasting  31  A major broadcasting milestone 360° immersive replays in basketball thanks to Intel’s True View technology  3,300  3D Athlete Tracking enhanced coverage of athletics sprint events  hours of UHD/ HDR coverage  1st Games to be fully produced natively in Ultra High Definition High Dynamic Range  10,200  hours of content produced by OBS  Transforming how the Games are broadcast  traditional international broadcaster in a whole year.  For Tokyo 2020, OBS once again pushed the boundaries of Olympic broadcasting by producing 44 per cent more content than it did for the Olympic Games Rio 2016, in more formats, to assist the world’s broadcasters in bringing the Games to more devices and platforms, and through more channels than ever before.  Throughout the Games, OBS also demonstrated how advances in technology can bring value to storytelling. Innovations for Tokyo 2020 included producing coverage of all sports natively in Ultra High Definition (UHD) High Dynamic Range (HDR) for the first time, providing four times more detail than standard HD and allowing viewers to enjoy a more immersive viewing experience. By the end of the Games, OBS had made more than 3,300 hours of UHD/ HDR coverage available.  This totalled more than 10,200 hours of content, including over 3,800 hours of live sports and Ceremony coverage, produced in just over two weeks – far more than the amount produced by a  Audiences around the world were also introduced to never-seen-before camera  “For OBS, these Games were a major milestone due to the advances we introduced.” Yiannis Exarchos, CEO, OBS  OBS Cloud launched, offering remote production  44%  more content produced than for Rio 2016  angles, 360-degree replays, multi-camera live Virtual Reality (VR) coverage and more analytical data processed by Artificial Intelligence (AI). This included 3D Athlete Tracking (3DAT) technology, developed by Worldwide Olympic Partners Intel and Alibaba, which offered a first-of-its-kind broadcast enhancement with near realtime insights and overlay visualisations. In addition, Tokyo 2020 saw the launch of OBS Cloud – an innovative broadcasting platform, developed by Alibaba, that operated entirely on the cloud. This allowed RHBs to carry out a significant part of their role remotely, making broadcast operations far more agile, flexible and efficient. “This partnership with Alibaba Cloud is transforming how we broadcast the Olympic Games to the widest possible audience,” explained Yiannis Exarchos, CEO of OBS. “This is perhaps the biggest technological change in the broadcasting industry for more than half a century, since the introduction of satellite.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "32  Global Broadcast Highlights “Globally speaking, the Games have been very dominant in terms of viewing and market share both on television and digital.” Timo Lumme, Managing Director, IOC Television and Marketing Services  Japan “Very large numbers of people watched the Games on our broadcasting and online services. The TV viewership for the Olympics Opening Ceremony hit the highest figure since the Tokyo 1964 Games.” Maeda Terunobu, President, NHK  The live broadcast of the Opening Ceremony was the most watched television broadcast for over  10 years in Japan.  A total  115.8m  viewers watched Tokyo 2020 coverage on TV – more than 91% of the Japanese population. At least  76.5m  viewers in the host nation watched the Games every day."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Broadcasting  33  USA “There is nothing more powerful in media than the 17 straight days of Olympics dominance. Once again, we have seen the unparalleled power that these Games have on media and our culture.” Pete Bevacqua, Chairman, NBC Sports  Overall, more than  120bn  minutes of Tokyo 2020 content was consumed across all NBC Universal platforms (television, digital and social).  More than  150m  With nearly  6bn  streaming minutes across digital and social media, Tokyo 2020 was NBC Sports Digital’s most streamed Olympic Games ever. Streaming platform Peacock, featuring Olympic Games coverage for the first time, recorded its best two weeks of usage.  Americans watched NBC’s Tokyo Olympics presentation, as the Closing Ceremony on NBC marked the 135th consecutive night of Olympic Summer Games coverage that NBC Olympics ranked number one in primetime."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "34  CHINA  Digital video views in China accounted for approximately  75%  The men’s 100m final in athletics and the men’s and women’s table tennis singles finals achieved the highest audiences during the Games, and were also the three most-watched sports broadcasts since the 2018 FIFA World Cup final.  of all digital views worldwide.  EUROPE “The Olympic Games is the biggest global event that goes far beyond sports and traditional sports audiences. The Tokyo Games are seeing digital numbers never seen before.” Jean-Briac Perrette, President & CEO, Discovery International  1.3bn  minutes of Olympic content were consumed across Discovery’s digital platforms.  Over  175m  people viewed Discovery’s coverage on TV and digital – 13 times more than PyeongChang 2018."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Broadcasting  35  great britain “We’re incredibly proud to have shone a light on some of the most remarkable stories to come out of Tokyo 2020.” Barbara Slater, Director, BBC Sport  There were  36.4m  TV viewers as BBC One had more hours of coverage than ever before.  BBC Sport’s coverage of the Olympic Games saw a record-breaking  104m  requests to watch Tokyo 2020 online. That figure tops the 74.4 million requests during Rio 2016.  france  More than  50m  French people watched coverage on France Télévisions’ channels – six million more viewers than Rio 2016.  French people spent an average of  7.53hrs  each watching Games coverage."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "36  canada “W hether watching online, through apps, social media or on television, millions of viewers across the country tuned in and engaged with CBC’s coverage each day, demonstrating the continued relevance of the Olympic Games.” 	Chris Wilson, Executive Director, Sports and Olympics, CBC  28m  TV viewers – 74% of all Canadians – tuned in for CBC/Radio-Canada’s coverage of Tokyo 2020, with CBC ranking as the most-watched network in Canada for 17 consecutive days, delivering a 21.4% audience share.  india  Viewership of the Tokyo 2020 Opening Ceremony was  three times higher compared with the Opening Ceremony of Rio 2016.  Canadians streamed  37m  video views on CBC digital platforms during Tokyo 2020, up 62% compared with PyeongChang 2018."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Broadcasting  37  brazil  Coverage of women’s surfing on 26 July was watched by  20.4m  people, at the time making it the highest rated non-football sports broadcast in Brazil since the start of 2020.  Australia “We came into the Games confident Tokyo 2020 would be a success, but the record-breaking reaction from audiences exceeded all expectations.” 	Kurt Burnette, Seven West Media Chief Revenue Officer and Director of Olympics  More than  20m  Australians tuned in to watch the Seven Network’s coverage of Tokyo 2020, making it the biggest television and streaming event in Australian history.  Australians watched more than Seven recorded the biggest prime time share for commercial free-to-air networks, with more than  60%  share across all days of the Games.  4.74bn  minutes on 7plus, making it the biggest digital event in Australian history. 7plus gained 44% new registered users during the course of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/ZM1IujV0Dos')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:32px;top:30px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Partnerships"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/lGuuGlc5JWA')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:432px;top:64px\" src=\"/tokyo2020/static/_content/black-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "40  Olympic Partnerships “The long-term support of our global partners means the Olympic Movement is able to enjoy financial stability and operational support, which helps to overcome challenges, such as those the world has faced over the last 18 months. And by redistributing 90 per cent of the revenues it generates, the IOC is also able to support sport and athletes globally, all year round.” Thomas Bach, IOC President  While the eyes of the world were focused on the inspiring performances of athletes such as Elaine Thompson-Herah, Karsten Warholm, Emma McKeon and Caeleb Dressel during the Olympic Games Tokyo 2020, behind the scenes the success of the Games was heavily reliant on another elite group: the Worldwide Olympic Partners. As members of The Olympic Partners (TOP) programme – the highest level of Olympic sponsorship – these leading multinational companies provided crucial technical services, products, expertise and funding that ensured the Games ran as smoothly and efficiently as possible – and that more athletes from more National Olympic Committees (NOCs) were able to compete and succeed on the world’s biggest sporting stage.  The TOP programme was launched in 1985, granting category-exclusive Olympic marketing rights to a select group of global partners, and has since provided a major source of revenue for the Olympic Movement. This income is distributed directly to sports organisations at all levels, including the more than 200 NOCs around the world, which use these funds to help develop and support their athletes, enabling them to send a team to the Olympic Games. The programme has therefore been a significant factor behind the increased universality of the Games, with more athletes from more NOCs now able to compete.  The Worldwide Olympic Partners*  * Allianz’s Worldwide Olympic Partnership and Coca-Cola/Mengniu’s Joint TOP Partnership began in 2021, but due to the rescheduling of the Olympic Games Tokyo 2020 to 2021, certain limited marketing rights were extended to these TOP Partners for this edition of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/azdsuVjHJY8')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:362px;top:830px\" src=\"/tokyo2020/static/_content/black-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  41  Innovation Through Collaboration  Innovation  ‘Innovation Through Collaboration’ is the strategic vision of the tenth generation of the TOP Programme, running from 2021-2024. • New concepts • New assets • Improved rights and benefits •	Greater cooperation between the IOC and the TOP Partners  Focus areas for collaboration include: Digital/data  Sustainability  Purpose-led initiatives in areas such as:  Gender equality  Youth empowerment  Diversity and inclusion  The impact of this new strategic vision could be seen in partner activations throughout the Olympic Games Tokyo 2020  But the TOP programme is about more than just money. The Worldwide Olympic Partners also play an integral role in the actual staging of the Games themselves, contributing products, services and expertise, while their global Olympic marketing campaigns help to promote both the Games and the Olympic values, and increase support for the Olympic athletes. In Tokyo, this support was as varied as it was widespread. From supplying cutting-edge technology to the Games  venues to providing a range of industry-leading products that were vital for day-to-day operations, the contributions of the Worldwide Olympic Partners were behind every inspiring performance and every unforgettable moment, with Tokyo 2020 once again demonstrating their vital importance to the success of each Games.  “Without the support of our Worldwide Olympic Partners, without their technology, expertise, people, services, products and financing, the Olympic Games would simply not be possible.” Jiří Kejval, Chair of the IOC Marketing Commission"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/dKiF7aFyvhY')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:571px;top:625px\" src=\"/tokyo2020/static/_content/black-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Airbnb “We’re proud to support athletes in their journey through our incredible community of hosts and guests who every day carry the Olympic spirit around the world.” Catherine Powell, Airbnb Head of Hosting  Fact BOX Exclusive category: Unique Accommodation Products, Unique Experiences Services and Olympian Experiences Services Member of the TOP Programme since: 2019"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:784px;left:72px;width:90px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/rAgnbc7L4e8')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:784px;left:162px;width:50px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/o8-z5CDakR0')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:797px;left:46px;width:26px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/o8-z5CDakR0')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:797px;left:73px;width:82px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/dKiF7aFyvhY')\"></a>\n      </div>\n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/o8-z5CDakR0')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:265px;top:812px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  Airbnb’s partnership with the IOC is focused on supporting athletes through opportunities for economic empowerment while creating memorable experiences for fans worldwide, as well as providing accommodation support for use while training and travelling.  Olympian & Paralympian Online Experiences For the Olympic Games Tokyo 2020, Airbnb worked with more than 200 Olympic and Paralympic athletes to host Experiences giving guests the chance to meet competing and retired athletes spanning more than 50 sports and 30 countries. Over 25 per cent of athletes who hosted Experiences were Paralympians, 50 per cent were women and five per cent were refugee athletes. The programming also included 10 Experiences hosted onsite from Tokyo, to bring fans as close to the action as possible.  Unique Stays Among athletes who hosted stays and Experiences on Airbnb during Olympic Games Tokyo 2020, was Scottie Pippen. The two-time Olympic gold medallist hosted three overnight stays at his Chicago home offering the opportunity to watch the Olympic Games on NBCUniversal’s broadcast networks. Pippen’s 1992 US Olympic men’s basketball teammates Larry Bird and Patrick Ewing joined the project hosting Online Experiences offering fans intimate discussions about their Olympic journeys. The project generated press interest across the world.  Athlete Stays... Made Possible by Hosts Airbnb’s Made Possible by Hosts campaign kicked off in February 2021. The campaign – consisting of a series of videos made using real photographs from guests staying in the homes of Airbnb hosts around the world – was launched with the aim of celebrating the uniqueness of hosted travel. On the day of the Tokyo 2020 Opening Ceremony, Airbnb launched three new spots (Lovers and Fencers; The Whole Team; Homes with Pools) telling the story of athletes who stayed in Airbnb homes. From a romantic getaway for two Olympic fencers to a team stay during a Paralympian’s qualifying meet, the campaign aims to show the more human side of athletes on real trips with their loved ones, teammates and coaches.  43  Airbnb500 programme Airbnb, in partnership with the IOC and the International Paralympic Committee (IPC), offered all Olympians and Paralympians who competed in the Olympic and Paralympic Games Tokyo 2020 the Airbnb500 – a USD 500 celebratory travel grant that all eligible athletes can use at their discretion for relaxing and recuperating or exploring a new destination. The Olympic Games Tokyo 2020 shined the light on the importance of personal well-being and self-care. With this programme, Airbnb and the IOC aimed to celebrate qualifying athletes and thank them for the courage, the joy and the hope they shared with the world. •	7,473 Tokyo Olympians and Paralympians were honoured through this programme •	USD 3.7m in Airbnb grants were issued to these athletes  Airbnb Athlete Travel Grant programme AiThe Airbnb Athlete Travel Grant is a programme that offers up to 500 athletes a year USD 2,000 in Airbnb promotional credit to use for training, qualification, and other travel accommodations. In an effort to recognise that many athletes have also felt the impact of the pandemic, this programme expands on Airbnb’s current support of athletes’ travel and accommodation needs leading up to and around the Games. •	500 Tokyo Olympians and Paralympians representing 95 countries in 63 sports were recognised through this programme •	USD 1m in Airbnb grants were issued to these athletes  200+  athletes hosted Online Experiences  10  Experiences hosted onsite from Tokyo"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/-OvYuAPx8BQ')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:7px;top:622px\" src=\"/tokyo2020/static/_content/black-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Alibaba Group  Fact BOX  “Together with the International Olympic Committee and the Olympic Broadcasting Services, we hope to take the Olympic Games to the next level with our cloud technologies. We are all very excited about digitally transforming the Olympic Games, starting from Tokyo 2020.”  Member of the TOP Programme since: 2017  Chris Tung, Chief Marketing Officer, Alibaba Group  Exclusive category: Cloud infrastructure, Cloud services, ticketing and e-commerce platform services"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:260px;left:44px;width:105px;height:33px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/fFCX1PXvnok')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:447px;left:88px;width:67px;height:13px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/vu20q4S1NrU')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:58px;left:243px;width:127px;height:32px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/opK92LajFM8')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:406px;left:242px;width:131px;height:31px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/fZUN_ahxUbY')\"></a>\n      </div>\n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/PGIJDEkwsMg')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:365px;top:387px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/3L94rv8n20Q')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:552px;top:50px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  After signing a historic 12-year partnership with the IOC in January 2017, Alibaba Group became the official “Cloud Services” and “E-Commerce Platform Services” partner of the Olympic Games. The unprecedented Olympic Games Tokyo 2020 provided an opportunity for Alibaba to help contribute to the Olympic Games’ digital makeover. Alibaba helped media broadcasters transmit the world’s largest sporting event to fans via the cloud, migrated the sale of merchandise online, and supported athletes’ training and recovery.  Let Hope Shine, Brighter Together Inspired by President Thomas Bach’s remarks that “the Olympic flame can become the light at the end of this dark tunnel,” Alibaba dedicated its Olympic campaign to the resilience of humanity in overcoming COVID-19. “Let Hope Shine, Brighter Together” showed how people around the world were united by the spirit of hope, and how they found ways to push through hardship. The campaign also featured Japanese Olympian Horigome Yuto, who made history by becoming the first ever Olympic skateboarding champion. Pioneering the way for skateboarding, a sport that was once stigmatised, and its entrance to the Olympic Games, Horigome inspired millions of fans around the world with his story of determination and hope.  45  Migrating Broadcasts to the Cloud For the first time in Olympic Games history, Olympic Broadcasting Services (OBS) used Alibaba’s cloud technologies to bolster its coverage of the Olympic Games. Alibaba launched the “OBS Cloud,” which supported service delivery for Rights-Holding Broadcasters (RHBs). This allowed media organisations to transport less equipment and reduce the number of technical staff needed to cover the Olympic Games Tokyo 2020. OBS’ content delivery platform, Content+, was fully migrated to the cloud to deliver short-form content, as well as to help with content asset management and content production. During Tokyo 2020, nearly 9,000 shortform content clips were produced by the OBS Content+ crew to help enhance RHB coverage. The thousands of clips were accessible by the RHBs’ digital and social media teams from around the world.  Digitising the Olympic Pin Tradition In order to maintain the tradition of Olympic pins, and to help Olympic Games attendees follow social-distancing protocols at the same time, Alibaba unveiled its digital Cloud Pins at Tokyo 2020. The coin-sized pins use Alibaba’s cloud technology to enable users to digitally display their name, track  Olympic broadcasts hosted in the cloud for the first time  Launched first-ever cloud-enabled digital pin  daily steps, and access a collection of digital pin artworks inspired by the 33 Olympics sports. Leveraging a wireless connectivity technology known as Near-Field Communication, pin users can also interact and make friends in a contactless way. Alibaba distributed the interactive pins to broadcasting and media professionals working at the International Broadcasting Centre (IBC) and Main Press Centre (MPC) to help them engage and exchange social media information safely and interactively during the Olympic Games Tokyo 2020.  Looking Ahead to Olympic Games Paris 2024 To generate excitement for the Olympic Games Paris 2024, Alibaba launched an activation for its campaigns at the iconic Trocadéro, across the Seine from the Eiffel Tower in Paris. Throughout the Olympic Games Tokyo 2020, visitors to the Trocadéro were able to enjoy a broadcast of Alibaba’s “Let Hope Shine” campaign videos."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/9FMfa3_R4rQ')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:552px;top:75px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "46  Allianz “Getting behind athletes’ hopes and ambitions as they inspired the world with confidence, a competitive spirit and outstanding performances at the Olympic Games was an exciting way to celebrate Allianz’s first year as a Worldwide Olympic Partner.” Oliver Bäte, Chief Executive Officer of Allianz SE  Fact BOX Exclusive category: Insurance Member of the TOP Programme since: 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:430px;left:61px;width:88px;height:13px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/9FMfa3_R4rQ')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:773px;left:156px;width:69px;height:13px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/w23ccvczunM')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:809px;left:45px;width:97px;height:13px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/UyShzvq-VMg')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  47  The movement will continue to bring Allianz’s brand promise of Confidence in Tomorrow to life and show how it cares and gets behind the people and moments that matter in people’s lives.  Getting Behind the Olympic & Paralympic Movements  Allianz officially began its eight-year worldwide insurance partnership with the Olympic and Paralympic Movements on 1 January 2021, building on a collaboration with the Paralympic Movement since 2006. Allianz’s partnership focuses on the power of sport to unite people, and is about getting behind the hopes, challenges and needs of athletes and the wider Olympic and Paralympic Movements. To mark its global partnership, Allianz launched initiatives to connect with athletes and fans across the world, including the #SparkConfidence movement and the announcement of the Support Dog Squad on Olympic Day. The Support Dog Squad provided emotional support dogs to help Tokyo 2020 hopefuls, with the campaign generating 1.1 billion impressions through PR and social media.  #SparkConfidence Movement As one of the world’s leading insurers, Allianz knows that in times of uncertainty, people seek stability, trust and want to have confidence in tomorrow. Through the #SparkConfidence movement, it wants to inspire people and show that even the strongest among us don’t go it alone, they have people in their corner that support them for what’s ahead. The movement encourages everyone to take a moment and reflect on where they get their confidence from and see how it can drive us to feel more self-assured in tomorrow. Starting both within Allianz and on social media, the company encouraged athletes, employees, volunteers and fans to share their story of what or who gives them confidence. This included Cate Campbell, Australian swimmer and winner of two gold and one bronze medal in Tokyo, and Clarisse Agbégnénou, French judoka and winner of two gold medals in Tokyo. The #SparkConfidence movement received almost 300 million ad impressions (digital views) on Olympics.com and Tokyo2020.com.  In addition to the athletes featured in the #SparkConfidence movement, Allianz supports athletes across the world. This includes hiring athletes, running Athlete Buddy Programmes to offer employees the chance to be mentored by an athlete and explore different development topics together, and working together with athletes as ambassadors. Allianz supported 16 ambassadors at the Olympic Games Tokyo 2020, who won a total of 10 medals between them.  For What’s Ahead Allianz’s partnership doesn’t stop at the Olympic Games. It will continue to get behind the Olympic and Paralympic Movements in markets around the world – from supporting athletes in their careers, either as ambassadors or as employees, to delivering insurance solutions and services.  1.1bn  impressions for the Support Dog Squad campaign  16  Supported 16 athlete ambassadors at the Olympic Games Tokyo 2020  300  Approximately 300 million ad impressions for the #SparkConfidence campaign on Olympics.com and Tokyo2020.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/ZekqS71yDHo')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:20px;top:545px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Atos “The Olympic Games Tokyo 2020 have made history in the way they have been delivered and will be remembered as the most digitally connected Olympics in history. As a long-standing partner of the IOC, Atos is committed to support the secured digital journey of the Olympic Games, including sustainable solutions towards ‘climate positive’ Olympics by 2030. As spectators were not permitted on-site for Tokyo 2020, Atos’s integration and digital technology expertise allowed fans to enjoy the Olympic Games 24/7, from any device, anywhere in the world.” Patrick Adiba, CEO of Major Events, Atos  Fact BOX Exclusive category: lnformation technology products, services and solutions Member of the TOP Programme since: 2001"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:270px;left:45px;width:144px;height:32px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/1l5xrdXaEVU')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:61px;left:242px;width:41px;height:14px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/_5fR1kjzdTg')\"></a>\n      </div>\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/oUkidq0xNU8')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:50px;top:575px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  Atos has been a key technology provider for the Olympic Movement since 1989 and the Worldwide IT Partner since 2001. Behind the scenes, the Atos team has brought their trusted digital expertise and long-term experience to ensure the successful IT delivery of the last 10 editions of the Olympic Games. For Tokyo 2020, several adaptations had to be made to provide the ever-more-critical digital services managed by Atos to fully support the Tokyo 2020 Organising Committee in their objective to host safe and secure Olympic Games for all participants.  Real-time Results and Edge Computing System Atos provided critical digital solutions to Tokyo 2020, including Olympic Diffusion Systems (ODS) and Olympic Management Systems (OMS) supporting the planning and operations of the Olympic Games. For the first time in Tokyo, Atos implemented edge computing technology in competition venues, allowing reduced processing time. Competition results collected could be delivered in real-time to the media and supporters around the world.  49  Cloud Atos delivered and fully managed all critical IT services remotely through the cloud to enhance delivery consistency and effectiveness. In line with its own commitments, Atos is actively participating in global efforts to reduce the environmental impact of the Olympic Games. This included: •	Implementing cloud native applications •	Supporting key technology rehearsal or systems homologations remotely  200,000  hours of technology testing remotely  50%  reduction in physical servers  •	Scaling down the number of physical servers from 250 to 135, reducing the energy consumption and reducing the carbon footprint of the Games.  Advanced Access Control System and Security With all its digital security knowledge, Atos managed to secure the entire IT infrastructure and critical services needed for the successful delivery of the Olympic Games. The Worldwide IT Partner developed the most innovative Advanced Access Control System (AACS) ever, which ensured accredited Olympic family members could safely access the 350 of venues entry points, reinforcing security and optimising the control and access to the official areas.  Modernisation of Applications Atos has enhanced digital transformation through the modernisation of applications. While apps were previously arranged by user type, Atos has widely implemented microservices to improve productivity and speed. As the secure, decarbonised digital technology landscape evolves, Atos teams are eager to pursue their commitment in bringing continuous innovation for the successful organisation of the next editions of the Olympic Winter Games Beijing 2022 and Olympic Games Paris 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/0wy0HnICCyM&t=1s')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:330px;top:676px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "50  Bridgestone “Tokyo 2020 underscored the Olympic Movement’s commitments to diversity, equality and inclusivity, which are closely aligned with Bridgestone’s core values. By providing products and services, along with more than 300 employees who volunteered throughout the Games, we were proud to play a part in creating an environment where athletes could finally chase their dreams and in supporting safe and efficient operations.” Shu Ishibashi, Member of the Board, Global CEO and Representative Executive Officer, Bridgestone Corporation  Fact BOX Exclusive category: Tyres, restrictive automotive vehicle services, non-motorised bicycles and diversified (rubber) products Member of the TOP Programme since: 2014"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  As the only Worldwide Olympic and Paralympic Partner with its global headquarters located in the host city, the Olympic and Paralympic Games Tokyo 2020 were a special moment for Bridgestone. In addition to serving as the Official Tyre of the Olympic and Paralympic Games, Bridgestone contributed a wide range of solutions, services, and expertise to help support a safe and smooth Games-time experience for everyone involved. As a global leader in sustainable solutions beyond tyres, this included supplying a variety of innovative, diversified products and services that are engineered to support reliable and accessible mobility, earthquake readiness, building efficiency and more. This included: •	Keeping the official IOC and IPC fleets in motion by providing its high-performing tyres to fit more than 3,000 vehicles, including cars and buses, unique concept vehicles that will help move athletes and officials, competition support vehicles, and more. •	Offering its network of automotive service centres in Japan to provide regular tyre checks and any necessary tyre services.  51  •	Supplying more than 800 non-motorised bicycles that offered convenient mobility for Tokyo 2020 officials, volunteers, and athletes. •	Ensuring venues were earthquakeready through its cutting-edge seismic isolation bearings that were installed at the Tokyo Aquatics Centre and Ariake Arena. These flexible structural supports isolate a structure from the ground to help reduce the spread of seismic shock and decrease the chance of damage in the event of an earthquake. •	Supplying specially-designed track bicycles for Team Japan athletes competing in the sprint events. •	Applying its tyre and rubber expertise to develop advancements in equipment for Team Bridgestone Para athletes in Japan, including rubber soles for prosthetic running blades and tyres for wheelchair tennis players.  Empowering Athletes – And All Individuals – To Chase Their Dreams Bridgestone has long believed in the power of sport to excite, unite, and inspire people across all borders and backgrounds. The company’s global  5,000+  tyre safety checks conducted during the Games  24  medals won by Team Bridgestone athlete ambassadors  Olympic and Paralympic message, “Chase Your Dream,” aimed to empower people of all abilities to persevere through adversity in pursuit of their dreams. Team Bridgestone athlete ambassadors were the primary voices for these efforts, with the company supporting the journey of more than 70 inspiring Olympians, Paralympians, and hopefuls in 20 countries to represent the brand – its largest global Team Bridgestone roster to date."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "52  Coca-Cola “Coca-Cola is proud to be a Worldwide Olympic and Paralympic Partner for Tokyo 2020. We are honoured to be a part of the movement that makes it possible for athletes from all over the world to come together to pursue their dreams and be a part of history.” Manolo Arroyo, Global Chief Marketing Officer, The Coca-Cola Company  Fact BOX Exclusive category: Non-alcoholic beverages Member of the TOP Programme since: 1986 Coca-Cola has supported every Olympic Games since 1928 and once again refreshed Olympic athletes, officials, volunteers and fans with its beverages and engaged consumers during Tokyo 2020, which marked The Coca-Cola Company’s first Games as a Worldwide Partner of both the Olympic and Paralympic Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:360px;left:242px;width:82px;height:18px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/eioI3v6OEbQ')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  53  80  placard bearers recruited for the Opening Ceremony to celebrate diversity  296m  media impressions of the I Belong Here campaign  Sustainability In support of Tokyo 2020’s sustainability concept – “Be better, together: For the planet and the people” – Coca-Cola worked with the Tokyo 2020 Organising Committee and other partners to help realise a more sustainable society in Japan and around the world, through the three themes of resources, inclusion and communities. With regards to resources, this included: •	Distributing 100 per cent recycled PET bottle products along the route of the Tokyo 2020 Olympic Torch Relay. •	Using bottle-to-bottle recycling to turn most of the bottles distributed and consumed at the competition venues into Coca-Cola products again. •	Using recycled PET bottles collected within The Coca-Cola System to produce fibres for the Tokyo 2020 Olympic Torchbearer uniforms. •	Providing every Olympian with a Powerade-branded squeeze bottle. Inclusion efforts included: •	Celebrating diversity by recruiting 80 Placard Bearers from all genders and backgrounds to lead the Parade of Nations as part of the Olympic and Paralympic Opening Ceremonies. •	Supporting Pride House Tokyo – a pop-up information centre and events venue that has created a permanent safe space for the next generation of LGBT+ youth as an enduring legacy of the Olympic and Paralympic Games Tokyo 2020. Work in communities included: •	Installing “Olympic and Paralympic Support Vending Machines” across  the country, where a portion of the proceeds was donated to the athletes. Several thousand Olympic and Paralympic Support Vending Machines were installed nationwide.  I Belong Here Coca‑Cola and the IOC worked together to promote their shared values and introduce Gen Z fans to the Olympics through the “I Belong Here” digital platform, which was launched ahead of the Tokyo 2020 Olympic Games. The platform featured a series of co-branded digital experiences promoting diversity and unity. Fans could create a personal digital banner illustrating their values and identity through the “My Flag Belongs Here” tool. Additional activations included the “My Story Belongs Here” Instagram filter and the “My Style Belongs Here” feature, enabling users to “recreate” iconic Olympic moments with various graphics.  Olympic Torch Relay  drive engagement while contributing to the digital transformation of the fan experience. Providing a platform for Coca-Cola to engage with fans in Japan and around the world, the PLAYNATION featured group experiences and games that could be played anywhere, whether through the Virtual Torch Relay, or gamification experiences. Coca-Cola also offered exclusive video content through unlockable rewards based on user engagement across the platform during the Games.  Digital Pin Trading Coca-Cola has been at the heart of pin trading, a treasured fan experience that celebrates the spirit of the Games, since the Olympic Winter Games Calgary 1988. In light of the pandemic, the Olympic Games Tokyo 2020 required events on the ground to look a little different. Coca-Cola therefore launched a digital pin initiative running via the Coke ON app in Japan, which allowed users to trade and collect pins digitally.  As a Presenting Partner of the Tokyo 2020 Torch Relay, Coca-Cola held a nationwide Olympic Torchbearer recruitment campaign in summer 2019 to ignite public attention for the coming Games and participation in the Olympic Torch Relay. For the 121 days of the Olympic Torch’s journey across all 47 of Japan’s prefectures, the Coca-Cola-sponsored convoy truck and Team Coca-Cola engaged the public and helped build excitement and enthusiasm for the start of the Games.  PLAYNATION In addition to Coke ON – its incredibly popular loyalty mobile application in Japan – Coca-Cola developed a virtual brand experience for the Olympic Games Tokyo 2020 called PLAYNATION, which helped  First-ever Joint TOP Partnership Agreement In 2019, the IOC, The Coca-Cola Company and China Mengniu Dairy Company Ltd announced the first-ever Joint TOP Partnership Agreement. The partnership combined the non-alcoholic beverage and the dairy categories into a new joint category, and brought Chinese dairy company Mengniu into the family of Worldwide TOP Partners. For more details, visit: Olympics.com/ ioc/partners/coca-cola-mengniu"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "54  Dow “As the Games’ Official Chemistry Company, it is a distinct honour for us to demonstrate the powerful connection between sport and science on the world’s largest athletic stage and bring new levels of materials science innovation and sustainability to many Olympic Games.” Michael Reed, Vice President, Dow Sports Marketing Solutions  Fact BOX Exclusive category: Chemicals, raw materials and compounds used across selected industries Member of the TOP Programme since: 2010"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  Cutting-edge solutions from Worldwide Olympic Partner Dow could be found throughout the Olympic Games Tokyo 2020, with the company’s materials science expertise helping power infrastructure technologies and deliver a sustainable legacy.  Better Building Performance From coating emulsions and insulation sealants to elastomers for electronic wiring, Dow supported the Games with solutions that enhanced sustainability and served as a catalyst for better building performance. This included within Tokyo’s Olympic Stadium, which was rebuilt for the Games and constructed with multiple Dow technologies in paints, coatings, insulation and wiring, and the Nippon Budokan – one of three major venues originally built for the Olympic Games in 1964 that were upgraded for Tokyo 2020. Known as the spiritual home of Japanese martial arts, structural protection of this important site is key, with Dow solutions helping reduce damage from moisture, shield the exterior walls by providing excellent dirt and water resistance, and protect the integrity of interior walls. In total, building solutions powered by Dow technologies were used during the retrofitting of nine of the pre-existing  55  Olympic venues, helping to elevate the performance and aesthetic of facades, building envelopes and electrical systems while delivering a sustainable legacy.  Recyclable Signs and Banners Collaborating with local partner Toppan, Dow elastomer technology was used to create a new polyolefin-based fabric for temporary banners with improved recyclability, which were used throughout Games venues and around the host city. Once the Games concluded, Dow and Toppan collected these banners and signs in order to upcycle them into different products. Collected banners or signage were re-palletised as a renewable resin and blended with timber from wood waste to produce wood-plastic composite materials for benches, floors and more.  Carbon Partnership As the Official Carbon Partner of the IOC, Dow ignites action among organisations both within and outside of the Olympic Movement to adopt technologies and practices that meet local market needs and deliver real third-party verified climate benefits. The cumulative results of Dow’s carbon programmes – which include Sochi 2014, Rio 2016 and Dow’s carbon partnership with the IOC – have so far delivered more than five million tonnes  9  existing venues were retrofit with Dow solutions that enhances sustainability and building performance  5m+  Dow’s carbon programmes— which include Sochi 2014, Rio 2016 and Dow’s carbon partnership with the IOC—have delivered more than 5m tonnes of CO2e reductions  of CO2e (carbon dioxide equivalent) reductions, earning external recognition and allowing the IOC to become carbon neutral, balancing its operational carbon footprint for 2017-2020."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "GE “GE was proud to provide innovative healthcare, energy, and digital solutions for the Olympic Games Tokyo 2020.” Eriko Asai, President & CEO, GE Japan  Fact BOX Exclusive category: Selected industrial equipment for systems used in energy, healthcare, transportation and infrastructure industries Member of the TOP Programme since: 2005"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  57  Athlete Medical Records provided a cloud-based solution to access and manage athletes’ medical files in a safe, secure way Energy Monitoring System enabled energy management across 36 Olympic venues  GE is the exclusive provider of a wide range of innovative products and services that are integral to staging a successful Olympic Games. From healthcare solutions for athletes to power connectivity across the Olympic venues, GE delivered critical, innovative services for the Olympic Games Tokyo 2020. This included GE’s proprietary Athlete Medical Records, powered by GE Healthcare’s Edison platform, which provided a cloud-based solution that allowed medical personnel across the  Games to access and manage athletes’ medical files in a safe, secure way. This enabled clinicians to provide proper treatment while protecting athletes’ personal medical data. GE also supplied a range of medical diagnostic equipment for the Olympic Village Polyclinic and the Games venues, helping clinicians predict, diagnose, treat and monitor health issues and sports injuries earlier when intervention is more effective and efficient. In addition to these healthcare innovations, GE helped enable power connectivity  across the Olympic venues through GE Renewable Energy’s Grid Solutions. This provided uninterrupted power supplies and switchgear for the International Broadcast Centre, Athlete’s Village, and other venues, ensuring stable and continuous power distribution. Meanwhile, GE Digital’s centralised Energy Monitoring System (EMS) enabled energy management across 36 event venues for the Games. EMS provided real-time visibility of energy use, enabling prompt diagnosis and problem-solving, as well as greater efficiency and reliability."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/u9-MO4_aA9A')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:563px;top:66px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      <div class=\"addContentLink\" style=\"top:748px;left:19px;width:333px;height:97px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/y6lCvzuUbKE')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "58  Intel “Intel plays a key role in accelerating the adoption of new technologies by working across the Olympic Movement to integrate technology into many facets of the Games – from sporting event operations and sports performance to improvements in host city infrastructure and providing data-rich fan experiences.” Rick Echevarria, Intel’s Vice President and General Manager of Intel’s Olympic and Paralympic Programme Office  Fact BOX Exclusive category: 5G technology platforms, VR, 3D and 360-degree content development platforms, artificial intelligence platforms, sports performance platforms, drones and processors Member of the TOP Programme since: 2017"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/UJyReGFKQU8')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:60px;top:66px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      <div class=\"addContentLink\" style=\"top:411px;left:242px;width:117px;height:19px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/iYv7oINQoGU')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  59  1,824  Intel Premium drones created spectacular light show during Opening Ceremony True View technology used in 35 4K cameras to produce 360° replays for basketball  Intel became a Worldwide Olympic Partner in 2017 and since then has been working with the IOC to reimagine the future of the Olympic Games through new levels of interaction, connectivity and fan experiences. For Tokyo 2020, Intel worked with the IOC, the Tokyo 2020 Organising Committee and a range of partners to highlight Intel’s ground-breaking technologies for use throughout the Games. As a technology leader, Intel maximised the capabilities of the latest technologies, including 5G platforms, AI (artificial intelligence) solutions, immersive media features and IT infrastructure for everyone involved.  Drone Light Show In one of the most spectacular moments from the Tokyo 2020 Opening Ceremony, a fleet of 1,824 Intel Premium drones lit up the sky above the Olympic Stadium, forming a complex set of geometrical shapes before transitioning into the blueand-white chequered emblem of Tokyo 2020. Symbolising the global solidarity and unity in diversity that the Games represent, the next-generation drones then reassembled to form a giant 3D representation of the world. Intel Drone Light Shows animators had collaborated closely with the Tokyo 2020 creative teams to incorporate the drones into the Opening Ceremony narrative, which aimed to show that the world and its athletes are stronger together through a display of connection, unity and hope.  3D Athlete Tracking Intel developed 3D Athlete Tracking (3DAT) – a first-of-its-kind platform that brings cutting-edge AI and computer vision motion tracking capabilities out of the lab and onto the field. 3DAT draws video from multiple cameras and then applies pose estimation and biomechanics algorithms to extract 3D form and motion from athletes. For Tokyo 2020, this data was used to enhance storytelling by being integrated into the Olympic broadcast through overlay visualisations that were made available during replays of several sprint events.  Intel True View Intel’s True View technology provided, for the first time, immersive replays during basketball matches at the Games, including 360° replays, bird’s-eye views and stunning freeze frames. This was achieved by installing small, highresolution cameras throughout the venue to capture the action from the entire court. A total of 35 4K cameras were mounted at the concourse level of the Saitama Super Arena to capture volumetric video, which was shared with rights-holding broadcasters in each country.  Tokyo 2020 5G Project Building on the introduction of 5G at the Olympic Winter Games PyeongChang 2018, Intel helped to demonstrate the expanded possibilities  of widespread deployment of 5G networks during Tokyo 2020. In collaboration with domestic partner NTT DOCOMO, Intel provided technology to support the utilisation of the 5G network infrastructure, improving connectivity and enabling new possibilities for immersive experiences. This included showcasing innovative sports viewing experiences at the Games that communicated events in previously unimaginable ways, including ultra-high-resolution broadcasts and augmented reality (AR).  Data Collection With the Olympic Games becoming increasingly data-driven, Intel worked with the IOC to initiate an automated data collection project that captured and analysed information related to the athletes and entourage, usage of venues and transportation during Tokyo 2020. Cameras and other sensors in venues and onboard Games transport collected information that helped increase understanding of infrastructure use and improve the accuracy of Gamestime operational data, while enhancing efficiency for future Games.  VR Training Ahead of the Games, Intel and the IOC collaborated to create a virtual reality (VR) training system to provide an immersive learning experience for key managers at competition venues. The VR platform helped improve training effectiveness by recreating a realistic experience and providing accurate individual feedback. This pilot initiative, tested for the first time in Tokyo, will help make operational training at future Games more efficient and cost-effective."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/A3yBbB-4eTU')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:574px;top:578px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      <div class=\"addContentLink\" style=\"top:782px;left:19px;width:337px;height:95px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/1FzSp5gXMeU')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "60  OMEGA “After a challenging year, it was so special to witness the Olympic Games taking place in Tokyo. OMEGA was delighted to time the occasion and support every athlete striving toward their dream. It is a great responsibility but also a massive honour to fulfil this critical role, and we are already looking forward to the next edition.” Raynald Aeschlimann, President and CEO of OMEGA  Fact BOX Exclusive category: Timepieces, timing, scoring and venue results systems and services Member of the TOP Programme since: 2003"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/rjnJlEFlsCU')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:54px;top:209px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/goo-wkU_Lag')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:352px;top:588px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      \n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  61  mark a new era of timekeeping, helping to redefine the way we watch and understand the Olympic Games. The systems were able to capture a range of in-depth data, such as the live speeds of swimmers, the live positions of runners, and even the speed of a volleyball, helping to tell the entire story of certain events. As well as showing spectators and commentators how the final results were achieved, they also enable athletes and coaches to analyse their performances with much greater insight.  OMEGA’s Timekeeping Highlights  At the Olympic Games Tokyo 2020, Swiss watchmaker OMEGA performed its historic role of Official Timekeeper for the 29th time since 1932. The technology required for the task has long since surpassed the stopwatches used in that original year, and now requires a team of 530 timekeepers and 900 volunteers, along with 400 tonnes of equipment. From photofinish cameras and scoreboards, through to starting blocks and touchpads, every detail ensures that the athletes are served with the world’s highest standard of precision and excellence.  OMEGA’s New Technology at Tokyo 2020 Seven sports in Tokyo featured OMEGA’s new motion sensor and positioning systems. These revolutionary technologies  Over the course of two inspiring weeks, OMEGA’s timekeeping team measured 1.3 million results. As always, some performances made a particularly notable impression, such as the 171 Olympic records and 31 world records measured - including the amazing 49.45 seconds in the men’s 100m butterfly set by the American swimmer Caeleb Dressel.  OMEGA’s Olympic Games Marketing For Tokyo 2020, OMEGA produced a full marketing campaign that reached audiences across the globe. Most prominent was the captivating television commercial, which has currently been watched around 75 million times on YouTube. The ad seamlessly blended the worlds of sport, watchmaking and Japanese culture together, and delivered  1.3m  results measured by OMEGA’s timekeeping team  400  tonnes of timekeeping and results equipment  75m  views of OMEGA’s Tokyo 2020 commercial on YouTube  a split-screen concept that was both inspiring and emotionally stirring. Furthermore, OMEGA’s presence was particularly notable on the wrists of certain athletes who wore the brand’s Seamaster Aqua Terra “Ultra Light” timepiece during competition. These included Armand “Mondo” Duplantis, who leapt to a gold medal in the men’s pole vault, as well as Noah Lyles, who took home the bronze medal in the men’s 200m sprint. Made from lightweight titanium, the watch has been specifically made for athletes, and offers a design that doesn’t get in the way of their performance.  OMEGA Tokyo 2020 Watches Three unique OMEGA timepieces were released to celebrate the Olympic Games Tokyo 2020, including: •	The Seamaster Aqua Terra Tokyo 2020 Limited Edition, with a ceramic dial laser-engraved with a distinctive Tokyo 2020 pattern. •	The Seamaster Planet Ocean Tokyo 2020 Limited Edition, which was a tribute to the flag of host country Japan, with a white ceramic dial and red-tipped seconds hand. •	The Seamaster Diver 300M Tokyo 2020, which was made in the colours of the event, with a blue ceramic bezel, a white ceramic dial, and a Tokyo 2020 emblem on the caseback."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/nNyxRF7puvc')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:564px;top:621px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>      \n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Panasonic “With support from the IOC, IPC, and OBS, we were able to contribute as a Worldwide Partner. Our AV equipment provided maximum support for the safe operation of the Games and delivered the passion and excitement of the athletes engaged in competition to the world.” 	Yoshihiro Morii, the Executive Officer in charge of Corporate Brand Strategy at Panasonic Corporation  Fact BOX Exclusive category: Audio/TV/video equipment, home appliances Member of the TOP Programme since: 1987"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  Panasonic Corporation, an Official Worldwide Olympic Partner for over 30 years and Paralympic Partner for over 20 years in the Audio and Visual Equipment category, contributed its cutting-edge AV technology to the Olympic Games Tokyo 2020.  Next-Generation Projectors Following its success at the Olympic Games Rio 2016 and the Olympic Winter Games PyeongChang 2018, Panasonic took projection mapping to the next level in its native Japan, with the company’s technology providing an exhilarating performance of light and colour at not only the Tokyo 2020 Opening Ceremony, but also at several competition venues.  63  The stunning presentations were achieved using Panasonic’s revolutionary, 50,000lumen RQ50 projectors, with Panasonic’s projection mapping technology illuminating the Olympic Stadium, the competition venue floors and walls, as a mesmerising light show complemented the dynamic movements of the dancers and performers.  Panasonic SPORTS CHANGE MAKERS As part of its SPORTS CHANGE MAKERS initiative, Panasonic encouraged students around the world to submit “ideas that break down barriers in sports and technology.” The final presentation of the competition was held in cooperation with the IOC and IPC following the conclusion of the Olympic Games Tokyo 2020. With the theme “Going Beyond Barriers,” regional qualification rounds were held for students in four cities scheduled to host future Olympic and Paralympic Games (Tokyo, Japan; Beijing, China; Paris, France; and Los Angeles, USA). After a rigorous selection process, four representative teams – one from each region – were selected in January 2020. In the final presentation, each team demonstrated their ideas to representatives from the IOC, IPC, and the Paris 2024 Organising Committee, as well as celebrities from around the world who were participating as advisors.  60  Approximately 60 Panasonic PT-RQ50K projectors provided mesmerising light and colour displays during the Tokyo 2020 Opening Ceremony  200  More than 200 entries received for the SPORTS CHANGE MAKERS contest  Prototype demonstrations for each idea, co-created by Panasonic and partner companies in collaboration with the students, were displayed at both the real and virtual venues to enable the attendees to experience the ideas in action. Through this project, Panasonic continues to support the dreams of students striving to contribute to the future sports scene."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "64  P&G “Over the past decade, we have been honoured to tell the stories of amazing athletes and those who have supported them on the journey to achieving their Olympic and Paralympic dreams. When those dreams were put on hold in 2020, we were inspired as they stepped up to help others and serve their communities. By putting others above themselves and lending their time and resources, these accomplished athletes show that their goodness is their greatness.” Marc Pritchard, P&G Chief Brand Officer  Fact BOX Exclusive category: Personal care, healthcare and household care products Member of the TOP Programme since: 2010"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:524px;left:133px;width:95px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/akKI70uJ9pg')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:536px;left:64px;width:151px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/E2rAXgR-qlw')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:785px;left:335px;width:66px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/yWur5IApW3A')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:592px;left:582px;width:20px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/BSa2OUQZCF0')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:604px;left:442px;width:69px;height:12px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/BSa2OUQZCF0')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  65  52  Charitable efforts of 52 athletes supported through the Athletes for Good Fund ahead of Tokyo 2020  24.5 For the Olympic Games Tokyo 2020, Procter & Gamble’s campaign was inspired by the many Olympic and Paralympic athletes who are not only achieving athletic greatness but are also stepping up to take action for good, making a positive difference in their communities.  In celebration of the athletes who show their goodness on and off the field of play, the Your Goodness is Your Greatness film spotlights those who are using their voices and their platforms for positive change. It demonstrates to the world that the true measure of greatness is goodness.  These incredible athletes were the focus of P&G’s Olympic Games Tokyo 2020 programme, the latest chapter in P&G’s worldwide “Lead with Love” campaign, uniting P&G’s longstanding Citizenship efforts of Community Impact, Equality & Inclusion and Environmental Sustainability.  Shining a Light on Athletes’ Acts of Good  Showcasing Love in Action P&G’s global Tokyo 2020 campaign included two films – “Love Leads to Good” and “Your Goodness is Your Greatness”. The film Love Leads to Good explores the important role parents have in raising their children to be good people. It shows the moments of teaching that build a child into a champion – as an athlete and as a human being – depicting how the choice to be a good person, above all else, reflects the lessons of love taught by those who raise them.  Inspired by athletes doing good in the world, P&G is taking action to encourage even more positive change through the Athletes for Good Fund. With the IOC and the International Paralympic Committee (IPC), P&G is proud to support the efforts of the 52 recipients making positive contributions in P&G’s citizenship areas. With more than USD 500,000 in grant funding, the Athletes for Good Fund contributes to P&G’s commitment of 2,021 Acts of Good in 2021. During Tokyo 2020, P&G presented a panel discussion, “Champions and the Causes They Champion”, hosted by Olympic legends Nastia Liukin and Gus Kenworthy and featuring several recipients to discuss the positive impact of their acts of good, both on and off the field of play. P&G also made on-the-spot donations in honour of athletes leading with love during the Games.  Taking Action for Equality & Inclusion P&G’s global campaign also included a documentary-style film series co-created with the IOC entitled “Good is Gold”, which tells the moving, real-life stories of four Olympic and Paralympic athletes and hopefuls as they take action against bias and inequality. During Tokyo 2020, P&G hosted a panel discussion, “Equal Representation in Sports: Why LGBTQ+ Visibility Matters”,  tons of recycled plastic collected to construct medal podiums – the equivalent of around 400,000 bottles of laundry detergent  which was moderated by Forbes. com contributor and LGBTQ+ activist Dawn Ennis. Gus Kenworthy and Abby Dunkin also took part in the panel, with participants discussing the importance of equal representation in sports and the steps needed to continue to drive equality across the sports landscape.  Uniting to Advance Environmental Sustainability For Tokyo 2020, P&G used the world’s biggest sporting stage to promote environmental sustainability with The Podium Project. In partnership with the Tokyo 2020 Organising Committee and the IOC, the Olympic and Paralympic medal podiums were created from recycled plastic. The Japanese public were crucial to the success of the programme. P&G’s retail partner placed collection containers in more than 2,000 locations, and over 100 schools included collection boxes as part of a programme to educate their students about responsible consumption and recycling. In total, 24.5 tons of recycled plastic – the equivalent of around 400,000 bottles of laundry detergent – were collected and used in the construction of the 98 podiums that were used during Tokyo 2020. Some of the collected plastic was also used to make face shields, which were donated to volunteers working at the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Samsung “The Olympic and Paralympic Games Tokyo 2020 were special for all stakeholders in various ways. However, the talent and stories of participating athletes shined bright and united the Games like never before. Samsung Electronics was proud to support the athletes of Tokyo 2020 as they continue to empower meaningful connections through our advanced mobile technology and contributions.” Younghee Lee, CMO & Executive Vice President, Samsung Electronics  Fact BOX Exclusive category: Wireless communications equipment and computing equipment Member of the TOP Programme since: 1997"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:274px;left:276px;width:128px;height:14px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/QGappMLeVLw')\"></a>\n      </div>\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/P18PfvuglKg')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:567px;top:53px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  Samsung’s relationship with the Olympic Movement began at the Olympic Games Seoul 1988 as a local sponsor. Samsung then elevated its partnership to Worldwide Olympic Partner for the Olympic Winter Games Nagano 1998. As the Olympic Partner in the Wireless Communications and Computing Equipment category, Samsung has supported the Games with innovative mobile technologies and transformed the way the Olympic and Paralympic community, athletes, and fans around the world communicate and share with each other.  Galaxy S21 5G Tokyo 2020 Athlete Phone Samsung continued its legacy of supporting Olympic and Paralympic athletes by providing them with exclusive Galaxy S21 5G Tokyo 2020 Athlete Phones to help maintain real-time connections, keep up with information, as well as capture and share memories of their experience. The limited-edition phone featured an Olympic rings design to commemorate Tokyo 2020. Additionally, in support of Tokyo 2020’s COVID-19 countermeasures, Samsung pre-installed the COCOA app for contact tracing and safety protocols on all 17,200 Galaxy S21 5G Tokyo 2020 Athlete Phones to further ensure health and safety on the ground for athletes and officials.  67  •	The Samsung Galaxy Tokyo 2020 Media Centre, which provided virtual experiences that that allowed media and fans to connect with the Games in more ways than ever before. •	The #TweetToClap campaign, which brought the fan applause back to the ears of Olympians through the ingenuity of social media and Galaxy. •	“World Lens,” which was developed and provided by the IOC and Samsung together in the Tokyo 2020 official app, to offer fans and athletes the chance to experience various cultures from around the world in AR. •	The #StrongerTogetherChallenge – a digital campaign jointly developed with the IOC, which provided consumers and fans around the world with the opportunity to feel the power of being stronger when together while walking and doing good.  On-Site Activation Located within the Tokyo 2020 Olympic and Paralympic Village, Samsung created the Galaxy Athlete Lounge – a secure place for athletes to engage with the brand and collect their Olympic and Paralympic mobile devices to stay connected to family, friends, and fans throughout the Games. Athletes also had the opportunity to learn more about Samsung Galaxy devices and pick up Olympic and Paralympic pins during their visit. Additionally, Samsung had an on-site presence at Galaxy Harajuku – its largest Galaxy location to date – to welcome local consumers and fans to experience the spirit of the Games and showcase its cutting-edge mobile technology.  Digital-Driven Marketing Samsung created virtual experiences for Tokyo 2020 that allowed fans to connect with the Games in more ways than ever before, celebrate the Olympic spirit and come together through 5G – no matter where they were. Through innovative digital experiences, Samsung was able to digitally bring the world together at the Games. Initiatives included:  Team Galaxy Ambassadors Samsung is committed to creating a global and inclusive team where everyone belongs and has equal opportunities, and Team Galaxy, Samsung’s official roster of Olympians and Paralympians, represents this commitment. In the lead-up to Tokyo 2020, Samsung partnered with world-class athletes who defied barriers and inspired fans through their athletic achievements and “off-field” contributions to their communities. #StrongerTogetherChallenge  1.2m+  people joined a virtual walk as part of the campaign  •	Samsung launched Galaxy House on Zepeto (Metaverse), a virtual platform that lets users create 3D characters of themselves. In Galaxy House, fans were able to experience new Samsung Tokyo 2020 marketing content and enjoy a new virtual pin promotion.  61.2%  of participants of the campaign were Millennials and Generation Z"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/wIXqUj9a15A')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:548px;top:328px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "68  Toyota  Fact BOX  “We believe that the power of sport lies in its ability to connect people with diverse personalities and backgrounds as they compete towards a common goal with mutual respect.”  Member of the TOP Programme since: 2017  Akio Toyoda, President, Toyota Motor Corporation  Exclusive category: Vehicles, mobility support robots and mobility services"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  Toyota introduced a diverse range of innovative mobility solutions at the Olympic Games Tokyo 2020, supporting the safe and efficient transport of athletes and officials and contributing to smooth Games-time operations.  e-Palette This included specially designed “Tokyo 2020 Version” e-Palette vehicles to support athlete mobility in the Olympic Village, with a battery-electric vehicle for autonomous mobility as a service (Autono-MaaS)* applications having been adapted specifically for use in Tokyo based in part on feedback from athletes about their mobility needs during previous Games. Features included large doors and electric ramps to allow groups of athletes to board quickly and easily.  69  In total, Toyota provided around 3,400 mobility products and/or vehicles for Tokyo 2020, with nearly 90 per cent of the official vehicle fleet being electrified. Electrified vehicles included hybrid electric vehicles (HEVs), fuel cell electric vehicles (FCEVs), such as the hydrogen-powered Mirai, plug-in hybrid electric vehicles (PHEVs), the Prius PHV (known as Prius Prime in some markets), and battery electric vehicles (BEVs).  Tokyo 2020 Robot Project  Accessible People Mover  Toyota also played a key role in the Tokyo 2020 Robot Project – an initiative led by the Tokyo 2020 Organising Committee that brought the government, Tokyo Metropolitan government, as well as Games partners together with experts in the field of robotics.  In addition, Toyota developed a new Accessible People Mover (APM) specially for use at the Games. These low-speed, short-distance battery electric vehicles (BEVs), offering “last one mile” solutions, hepled to transport athletes and officials within venues, especially those with special mobility needs, and were also deployed to support relief activities during events, with the second and third rows adapted to accommodate a stretcher.  At Tokyo 2020, the robots introduced by Toyota included Field Support Robots to retrieve sports equipment quickly and safely on the field of play, alleviating the burden on operational staff, mascot robots that provided immersive experiences for children across Japan, and CUE – an AI-powered basketball-playing robot that wowed viewers with its shooting prowess.  3,400  Toyota provided around 3,400 mobility products and/or vehicles for Tokyo 2020  90%  Electrified vehicles accounted for almost 90% of the official fleet  Olympic Torch Relay As a Presenting Partner of the Tokyo 2020 Olympic Torch Relay, Toyota helped build excitement for the Games and empowered people across Japan, including through a campaign to recruit torchbearers. As Official Mobility Partner, Toyota also took part in the Olympic Torch Relay with vehicles, providing the lead car and showcasing exciting new mobility technologies. *Combination of “autonomous” and “mobility as a service”, describing Toyota’s mobility services using automated driving vehicles."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/hsQ-EcK39Ng')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:566px;top:618px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a> \n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Visa  Fact BOX  “As the world watched athletes compete without friends and family at their sides after a year-long delay that tested their resilience, they gave us the fortune of watching both record-breaking athletic performances and moments that transcended competition and nationality.”  Member of the TOP Programme since: 1986  Andrea Fairchild, Senior Vice President of Global Sponsorship Marketing, Visa  Exclusive category: Payment services, transaction security, pre-paid cards"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "\n\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  71  102  athletes from 28 sports supported as part of Team Visa  244,378  votes cast for the Visa Award during the Olympic Games  As the Worldwide Payment Technology Partner, Visa was committed to leaving an impact on the Japanese economy and its people both during the Olympic Games Tokyo 2020 and beyond the Closing Ceremony. To ensure the best onsite digital payment experiences, and in support of the government’s “Cashless Japan” initiative to double the total of payments made digitally to 40 per cent by 2025, Visa incorporated 5,000 contactless-enabled payment terminals at 42 official event venues throughout Japan. In doing so, Visa helped contribute to a safer and faster way for Games attendees to pay, allowing for a better onsite experience.  Team Visa Since launching the Team Visa program in 2000, Visa has championed more than 500 Olympic and Paralympic athletes and hopefuls, as part of overall efforts to empower athletes to be successful both on the field and off. For Tokyo 2020, Visa supported its largest and most diverse Team Visa roster ever, with more than 100 athletes spanning 54 markets across 28 sports, including representation from new sports including BMX freestyle, skateboarding, sport climbing, and surfing.  In a historic first, the Team Visa roster for Tokyo 2020 also included two associates of Visa’s Olympians & Paralympians in Business Development Programme (OPBDP) – a two-year rotational programme that introduces participants to a variety of business areas at Visa.  Brazilian skateboarder Rayssa Leal received the most votes to become the first recipient of The Visa Award for the Olympic Games, with voters recognising the 13-year-old silver medallist’s efforts to lift her rivals’ spirits with acts of kindness, friendship and solidarity.  Visa Award  As her prize, Visa donated USD 50,000 to Social Skate – a non-profit chosen by Leal that aims to make a positive contribution to the lives of socioeconomically vulnerable children and adolescents in Brazil.  Ahead of Tokyo 2020, Visa collaborated with the IOC and the IPC to launch The Visa Award, giving fans the opportunity to vote for their favourite moments of Olympians and Paralympians rising above the competition during the Games. The new accolade aimed to celebrate friendship, inclusion, acceptance and courage by honouring athletes who best exemplified these values during the Games. A selection of the most emblematic moments were then presented for fan voting.  New Zealand’s Holly Robinson then won The Visa Award for the Paralympic Games. Robinson, who took home gold in the women’s javelin F46 event, was recognised by fans for going out of her way to thank match officials and including them in her victory celebration. Her chosen charity, Ronald McDonald House, also received a USD 50,000 donation from Visa."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "72  Domestic Partnerships “The fact that the Tokyo 2020 Games were able to overcome the first postponement in the history of the Olympic Games and be successfully hosted was thanks to the contribution of our 67 domestic partners, all of whom continued to provide a high level of knowledge and service following the decision to postpone.” Komiya Masaaki, Tokyo 2020 Vice Director General  Under the direction of the IOC, the Tokyo 2020 Organising Committee managed its own domestic sponsorship programme, granting exclusive marketing rights within Japan. Consisting of three tiers – “Gold Partners”, “Official Partners” and “Official Suppliers” (Tier 3) – the Tokyo 2020 sponsorship programme was the most successful domestic sponsorship programme in Olympic history, generating record revenue to support the delivery of the Games.  Asahi Breweries, Ltd Asahi Breweries, Ltd. produces and sells beer and other alcohol beverages such as liquor, ready-to-drink beverages, wine, and shochu, as well as non-alcohol beer-taste beverages. It works to meet the diverse needs of its customers in the Japanese market through the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  73  Tokyo 2020 Gold Partners  and photographers from all over the world who gathered in Japan to capture breath-taking images and historical performances of the world’s top athletes. These images have now immortalised the Games, evoking memories and the wonderful spectacle of Tokyo 2020.  ENEOS Corporation  provision of a broad range of products in each beverage category. The company proactively supported the Japanese Olympic and Paralympic team, promoting the Olympic and Paralympic Movements, and helping to build excitement ahead of the Games as the only beer producer designated as a Tokyo 2020 Gold Partner.  ASICS Corporation ASICS aims to contribute to the realisation of a healthy and sustainable society by promoting sport in line with its vision to ‘create quality lifestyles through intelligent sport technology’. ASICS supported the Olympic Games Tokyo 2020 though sporting goods by producing official sportswear for the Japan National Team and cooperating to provide uniforms to the Field Cast staff, City Cast volunteers, and other people  involved in the Games. The company aimed to contribute to the Games at every level, incorporating principles such as heat protection, sustainability, and diversity into the apparel that was provided. As a Japanese sporting goods manufacturer, ASICS took pride in providing products and services that helped to make the Olympic and Paralympic Games Tokyo 2020 an event that Japan could be proud of.  Canon Inc. Based on the key concept of ‘capturing the most pivotal moments of the Games and sharing these emotions,’ Canon provided behind- the-scenes support to professional photographers from around the world via its loan services for cameras and lenses, and by providing a range of maintenance services. During the Olympic Games Tokyo 2020, Canon provided world-class services to sports journalists  ENEOS is committed to the creation of a new society based on hydrogen energy, which is expected to become more widely used owing to the opportunities provided by the Olympic Games Tokyo 2020. ENEOS operates the largest network of service stations in Japan (approximately 13,000 locations) and supported the Olympic Games Tokyo 2020 by supplying essential energy sources such as petroleum, gas, hydrogen, and electricity. During 2021, each service station also functioned as a hub to promote the Games and support events such as the Olympic Torch Relay. Fulfilling its responsibilities as a Gold Partner, ENEOS also aims to ensure the Games provide a human legacy well into the future, implementing a variety of actions to bring high-powered energy to all under its slogan, “ENERGY for ALL.”  Tokio Marine & Nichido Fire Insurance Co., Ltd. Since 1879, Tokio Marine & Nichido Fire Insurance Co., Ltd. has provided customers and society with a sense of safety and security and been there to support them in their time of need. As a Tokyo 2020 Gold Partner in the category of non-life insurance, the company provided insurance and risk management services to contribute to a safe and successful Games. Tokio Marine & Nichido strongly believes in diversity and creating an inclusive environment in which all employees can maximise their potential and contribute to the sustainable growth of the company. It believes the Olympic Games Tokyo 2020 will deepen"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "74  the company’s understanding of diversity and that the Games will contribute to a more inclusive Japan built on mutual understanding and peace of mind for all. Through the Olympic Games Tokyo 2020, Tokio Marine & Nichido will continue to contribute to the growth of Japan and strive to realise a better future for all.  Nippon Life Insurance Company Nippon Life has offices in all prefectures of Japan, including areas affected by disasters and outlying islands. Its 70,000 employees across Japan are striving to build stronger relationships with the company’s 12 million customers by remaining closely involved in each customer’s life for the long term. This is being accomplished through meticulous consulting services for customers throughout Japan. Against this backdrop, Nippon Life carried out activities on a daily basis in preparation for the Olympic and Paralympic Games Tokyo 2020. The company adopted the slogan “Play, Support. Let’s start supporting each other,” and undertook daily activities that aimed to convey the importance of cheering and supporting, by spotlighting Olympic athletes including those who represent Japan, as well as their supporters. By contributing to the success of the Olympic Torch Relay and the Olympic Games Tokyo 2020, the company aims to build a legacy that brings brightness into society through areas such as sports expansion, health improvement, educating future generations, encouraging diversity, and developing regional societies.  NEC Corporation NEC has established itself as a leader in the integration of IT and networking, providing new social value in public safety and more, underpinned by innovative technologies including biometric authentication, behaviour detection, and software-defined networking (SDN). With a rich history of supporting sports and culture that promotes a diverse and inclusive society, NEC strives to create a more sustainable world where everyone can realise their full potential. This is embodied in NEC’s provision of face recognition systems, deployed for the first time in the history of Olympic and Paralympic Games. This enabled instant identity verification using unique technologies with the highest accuracy in the world. NEC was proud to be the Tokyo 2020 Gold Partner in public safety and network products. Through supporting this world-class event, NEC aspires to create a legacy that enables a prosperous and safer society for generations to come.  Nippon Telegraph and Telephone (NTT) Corporation Following the Tokyo 2020 Organising Committee’s vision of creating a diverse and inclusive society, NTT provided information and communications services for the Olympic Games Tokyo 2020 to connect people and Japan with the world. Through its communications services, NTT contributed to the Games to achieve the following goals: •	Offering the ultimate level of hospitality to Games fans, as well as to competing athletes and Tokyo 2020 personnel. •	Operating the information and communications infrastructure that underpinned Tokyo 2020’s vision in a secure, safe, and reliable manner. •	Realising a Games that could be enjoyed not only at the venues, but also by people throughout Japan and around the world.  Nomura Holdings, Inc. Nomura is a global financial services group with an integrated network spanning over 30 countries. Founded in 1925 – and driven by the insights of its diverse team worldwide – Nomura puts its clients at the heart of everything it does, delivering unparalleled service and solutions to meet their individual needs. Nomura became a proud supporter of the Olympic and Paralympic Games Tokyo 2020 in March 2015. As Gold Partner in the securities category, Nomura supported athletes,  and those working alongside them, on their journey to be their best and reach their highest goals.  Fujitsu Ltd Fujitsu is constantly conducting a diverse array of initiatives to contribute to society, including initiatives to support sporting activities, with the overarching aim of realising a prosperous future that fulfills the dreams of people throughout the world. The Olympic Games Tokyo 2020 set the scene for wide-ranging interactions between people from countries all over the world, as well as for mass exchanges of information and infrastructures, becoming a hub of innovation. Accordingly, the occasion called for safe, sound and reliable Games operations to connect the various ICT technologies and to engender new emotions for people watching sport, doing sport and supporting sport. Fujitsu’s hardware technologies for the data centre, which included servers, storage systems and peripheral services, played a vital role in the delivery of the Olympic Games Tokyo 2020, and made a significant contribution to safe, sound and smooth Games operations.  Mizuho Financial Group, Inc. Mizuho is a leading Japanese financial institution, with a history that can be traced back approximately 150 years to when one of its predecessor banks was founded as the first bank in Japan. Mizuho offers a broad range of comprehensive financial and strategic services through its group companies including Mizuho Bank"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Olympic Partnerships  and Mizuho Trust & Banking. Mizuho’s relationship with the Olympic Games dates back to supporting the organisation of the Olympic Games Tokyo 1964 by storing the official Olympic flag and tickets. For the Olympic Games Tokyo 2020, Mizuho provided financial-related support and expertise to Olympic and Paralympic Games-related business and contributed to the success of the Games through its nationwide network of branches and offices.  Sumitomo Mitsui Financial Group, Inc. Sumitomo Mitsui Financial Group, Inc. (SMFG) is a global financial group that develops operations in a wide range of fields including banking, leasing, securities, credit cards, and consumer finance. Amongst the group companies, Sumitomo Mitsui Banking Corporation, the core bank of the group, utilising SMFG’s network of 148 branches and offices in 40 countries and regions around the world and leveraging the various products and services in which it possesses global strengths, has built a framework that can meet a wide range of domestic and overseas customers’ needs. Through the Olympic Games Tokyo 2020, SMFG united the collective strengths of the group toward the future of Japan and  75  development of the world to meet the expectations of its customers.  Mitsui Fudosan Co., Ltd. Mitsui Fudosan is one of Japan’s largest global real estate companies. Based in Tokyo, the company is also engaged in urban development projects in locations including New York, London, Shanghai, Chinese Taipei, Kuala Lumpur and Bangkok. As a Gold Partner of the Olympic and Paralympic Games Tokyo 2020 in the real estate development category, Mitsui Fudosan aimed to convey the values the company embraces in its urban development – sports, tradition, culture and the spirit of hospitality.  Meiji Co., Ltd. Meiji provides its customers with a wide range of products, such as milk, yogurt, cheese, ice cream, chocolate, and nutritional products, and was a Tokyo 2020 Gold Partner in the “Dairy Products & Confectionery” category. Meiji recognises that in order for people to lead healthy lives, exercise and a nutritionally balanced diet are indispensable. For many years, it has been providing dietary education and nutritional support for athletes. Leveraging its extensive experience and expertise in this field, the  company launched its ‘Meiji Tokyo 2020 Fes’, which aimed to educate children about the enjoyment of sport and the importance of healthy food.  LIXIL Corporation LIXIL was formed in 2011 through the merger of five major Japanese building material and equipment manufacturers. Today, it is a global corporation with approximately 60,000 employees in more than 150 countries around the world, and over a billion people use its products every day. Approaching the Olympic Games Tokyo 2020 with the slogan, “Change the future through Omoiyari and Omotenashi,” LIXIL aimed to realise a universal society where people can lead affluent, comfortable lives through educational programmes such as its Universal Run (Sports Prosthesis Experience Class) and by supplying aluminium previously used in temporary housing for the victims of the 2011 Great East Japan Earthquake as material for the Olympic Torch, the Tokyo 2020 Recovery Monuments project, and the Olympic/Paralympic logo for the victory podium. LIXIL also contributed to the Games through design, operational support, and products it provided for athletic events and the Olympic Village."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Fan Engagement"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "78  Fans were only able to attend a limited number of events during the Olympic Games, at venues outside Tokyo  Fan Engagement “Tokyo 2020 is the most digitally engaged Olympic Games ever.” 	Yiannis Exarchos, CEO of Olympic Broadcasting Services (OBS)  While most spectators were not able to attend the Olympic Games Tokyo 2020 in-person, fans in Japan and around the world were still able to experience the thrill of the Games thanks to widereaching engagement initiatives. Drawing on new technologies and digital innovations, more sports fans than ever were able watch, follow and engage with the Games, making Tokyo 2020 the most engaged Olympic Games ever.  In total, the Olympics web and app platforms for Tokyo 2020 attracted more than 196 million unique users, drawing more than three times the amount of online traffic as the Olympic Games Rio 2016, while the IOC’s social media handles generated more than six billion engagements – including video views, shares, comments and likes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Fan Engagement  79  Digital Engagement Ever since the adoption of Olympic Agenda 2020 in December 2014, which led to the successful launch of the Olympic Channel, the IOC has sought to create a closer connection with people around the world through digital platforms, aiming to engage fans and attract new followers not only during but also between each edition of the Olympic Games. The evolution of the IOC’s digital strategy continued in 2021 following the adoption of Olympic Agenda 2020+5 – the organisation’s latest strategic roadmap – in which recommendation 8 states: “Grow digital engagement with people”. In line with this recommendation, the IOC launched Olympics.com in the build up to the Olympic Games Tokyo 2020, providing a single, people-centric digital platform that better utilises Olympic digital  and social media channels to drive engagement and deliver content and communications. Offering a comprehensive source for Olympic information, news and original content, Olympics.com has created a single destination for all Olympic online properties – including the Olympic Channel, Tokyo 2020 and all future Games – allowing for improved, streamlined digital engagement during and between each Games.  Future features of the site will include more personalised user experiences, ticketing, fantasy games and an Olympic e-commerce presence. To further enhance the IOC’s digital media presence, official Olympic social media channels have been consolidated into @olympics accounts across global platforms including YouTube, Facebook, Instagram, Twitter and TikTok.  “We believe that, by embracing digital engagement, we can build even stronger relationships with people and promote the Olympic values to a wider, younger audience.” Yiannis Exarchos, CEO of OBS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "80  Digital Fan Engagement To allow fans all over the world to feel more engaged with the Olympic Games Tokyo 2020, and enable them to be actively involved in supporting their favourite athletes, the IOC and Olympic Broadcasting Services (OBS), working with the Tokyo 2020 Organising Committee and Olympic broadcast partners, implemented a ground-breaking digital remote fan engagement solution. The project featured a suite of unique digital tools, with Tokyo 2020 becoming the first major international sports event to implement an innovative new Digital Fan Engagement solution. Through an online platform, fans around the world were able to share their reactions to the sporting action by uploading five-second video selfies, which were then displayed as a video matrix inside the Games  venues, allowing fans to feel like they were genuinely part of the Olympic experience. In addition, a virtual “cheer” button gave fans the opportunity to show their support during events by virtually clapping or cheering by clicking the button. After collecting each cheer, the system  “The world is reacting, wants to engage, wants to make its presence known in the venues. The athletes should not feel that they’re alone. They’re supported by hundreds and hundreds of millions of people around the world.” Yiannis Exarchos, CEO of OBS  most digitally engaged Olympic Games ever  250 million+  digital ‘cheers’  Digital Fan Engagement solutions launched  3.4 times more  people reached through web and app compared with Rio 2016 (58m v 196m)  rendered a global “cheer map” which was available as a video stream and shown on venue video boards. In total, more than 250 million cheers were registered during the Games, coming from every country and supporting athletes from all 205 National Olympic Committees and the IOC Refugee Olympic Team.  196m  unique users on the Olympics web and app for Tokyo  Olympics social media followers increased by 9% during the Games  6.1bn engagements on Olympics social media handles"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Fan Engagement  81  Ticket and Hospitality Sales While COVID-19 countermeasures ultimately meant that most spectators were unable to attend the Olympic Games Tokyo 2020 in-person, the Tokyo 2020 Hospitality and Ticketing programmes had been on track to become the most commercially successful in Olympic history, demonstrating the excitement of fans in Japan and around the world.  The Athlete Moment initiative allowed Olympians to immediately connect with family and friends  Athlete Moment The Athlete Moment initiative, delivered in partnership with OBS, allowed Olympians to connect with their family and friends straight after finishing their competition. In select venues, special Athlete Moment screens provided direct video links between the athletes and their selected friends and family, enabling them to connect and celebrate their performances together.  Digital Hospitality Houses Hospitality houses hosted by National Olympic Committees and other stakeholders have become a traditional part of the Olympic Games but, with COVID-19 countermeasures in place for Tokyo 2020, innovative digital offerings were developed instead. Featuring live events and virtual exhibitions, as well as exclusive photos, information and offers, these digital hospitality houses created a new way to connect with communities and celebrate the Games together.  “I knew they were with me but to see them right after my race and right after I got my medal was amazing. To swim good is really nice, but to share it with your family and friends and your loved ones, that makes it even better.” 	Arno Kamminga (NED), silver medallist, men’s 100m and 200m breaststroke  The Ticketing Programme had already sold more than 7.1 million tickets – a record compared to the Olympic Games Rio 2016.  Despite COVID-19 countermeasures, Tokyo 2020 were also still able to operate a limited number of live sites to engage local fans. Tatjana Schoenmaker (top) and Arno Kamminga (bottom) were among those to enjoy the Athlete Moment screens"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/sHXcWvZr-9c')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:474px;top:788px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a> \n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "82  Usain Bolt was among the Olympians who starred in the IOC’s Stronger Together campaign  Stronger Together In June 2021, the IOC launched “Stronger Together” – a global Olympic campaign that celebrated athletes by showcasing their journey to the Olympic Games Tokyo 2020, and how they kept moving even when the world around them stopped. The story highlighted their strength, resilience and determination to bring hope, unity and inspiration to people around the world. The campaign film, starring worldrenowned athletes such as Usain Bolt, Naomi Osaka, Tony Hawk, Yusra Mardini and Nyjah Houston, emphasised the IOC’s message of solidarity and the belief that  the world moves forward only when it moves together. The film also highlighted the power of the Olympic Games to unite people, communities and societies across the globe and helped build excitement and engagement ahead of Tokyo 2020. The campaign launch on Olympic Day (23 June) was also supported by a number of digital engagement activities, including a virtual yoga session with snowboarder Christy Prior, live chats with Usain Bolt and Japanese surfer Kanoa Igarashi, and a workout session and Q&A with tennis star Venus Williams.  7.8m+  views on athlete and Olympic channels  2.94bn  impressions generated by the #StrongerTogether campaign via consumer PR  The campaign highlighted the power of the Olympic Games to bring people together"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:84px;left:44px;width:364px;height:43px\">\n        <a href=\"https://twitter.com/olympics/status/1411648483736444930\" target=\"_blank\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Fan Engagement  83  Tokyo 2020 FanZone In May 2021, the IOC launched the Tokyo 2020 FanZone – an interactive gamification experience on Olympics.com and the official Tokyo 2020 website and mobile app, which aimed to engage and unite fans around the world leading up to and throughout the Olympic Games. The interactive platform enabled fans to win prizes by testing their knowledge in regular Trivia competitions and enjoy thrilling highlights of past Olympic Games in the Magic Moments section. Once the Games began, the Fantasy and Bracket Challenges brought the real-time fantasy sports experience to the Olympic Games for the first time. With the Fantasy Challenge, fans could create a team by selecting their 10 favourite athletes from individual sports and then start a league with friends or join an existing one to compete against other teams.  The Bracket Challenge, meanwhile, saw fans attempt to select the winning bracket in each team sport while competing with friends and other fans around the world. The FanZone experience was supported by TOP Partners Panasonic, Swatch/ Omega and Bridgestone, which provided prizes for participants and winners.  5.7m  unique users reached by the FanZone  “FanZone serves as an important element of our digital efforts for fans to feel they are part of the Tokyo 2020 Olympics.” Yiannis Exarchos, CEO of OBS  10.1m total FanZone page views"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "84  Digital Partnerships The IOC partnered with major digital platforms to further engage fans during the Games. This included creating dedicated content hubs across TikTok, Twitter and Facebook to allow fans to engage with the latest content from the ground in Tokyo, giving them easy access to their favourite teams, athletes and sports.  Fans were encouraged to get active through a body-tracking AR lens on Snapchat  For the first time ever, the official #OlympicGames emoji was available on Twitter, while fans could also bring select athletes to life in augmented reality by simply typing each athlete’s name into Google Search on an AR-compatible phone. Snapchat users were also encouraged to embrace the spirit of the Games through a body-tracking AR Lens on the official Olympics account, which incentivised them to stay active. On TikTok, fans were able to participate in the #OlympicSpirit hashtag challenge to share how they were celebrating the Games, while users on Instagram were challenged to match the poses of the Olympic mascot in the correct sequence. In China, the IOC collaborated with Worldwide Olympic Partner Alibaba’s Taobao Brand Hub to provide competition schedules, results and updates, as well as fan engagement campaigns. In addition, the IOC offered updates and fan-focused content via Weibo and Douyin for Chinese speakers.  The #OlympicSpirit challenge asked fans to share how they were celebrating the Games  6.7bn  engagements driven by digital partnerships  18.5m  unique users driven to Olympics.com from digital partnerships"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 84,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg85.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/TM4CYbTNzGc')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:238px;top:252px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/KCcLkyW9gAQ')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:44px;top:805px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a> \n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Fan Engagement  85  Make the Beat For the first time at an Olympic Games, an official ‘cheering beat’ was created to build excitement among fans and enable them to show their support for Olympians during the Games. The official Tokyo #2020beat was created from approximately 1,000 different sound samples reflecting the themes of sport, Japanese culture, and nature. Five different rhythms were compiled from these samples using AI technology from Worldwide Olympic Partner Intel, with researchers from Tsukuba University then contributing to the final selection of the official beat.  The Tokyo #2020beat was created from approximately 1,000 different sound samples  In the build-up to the Games, fans around the world were invited to film themselves performing the rhythm by dancing, clapping or stomping, and to post their content on social media using the special  hashtag #2020beat. A selection of these posts was then displayed in venues during Games time as a compilation generated using Cloud technology from Worldwide Olympic Partner Alibaba.  The official ‘cheering beat’ was launched to help build excitement among fans and enable them to show their support for Olympians during the Games"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 85,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg86.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "86  Olympian and Paralympian Online Experiences To celebrate the spirit of the Olympic and Paralympic Games, the IOC, in partnership with Worldwide Olympic Partner Airbnb and the International Paralympic Committee (IPC), gave people the chance to experience the Games like never before through a new collection of Olympian and Paralympian Online Experiences on Airbnb. Under the banner of “Tokyo Together”, this exclusive programme of over 200 Olympian and Paralympian Online Experiences helped fans feel closer to the action by bringing the magic of the Games into their homes, while also enabling them to celebrate and support the athletes.  “Olympian and Paralympian Online Experiences allow fans to feel closer to their heroes than ever before.” 	Catherine Powell, Airbnb Global Head of Hosting  More than 200 Olympian and Paralympian Online Experiences were available during the Games"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 86,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg87.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:544px;left:44px;width:245px;height:41px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/eioI3v6OEbQ')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Fan Engagement  87  I Belong Here In celebration of Tokyo 2020 and the unity in diversity that is seen only at the Olympic Games, the IOC and Worldwide Olympic Partner Coca-Cola collaborated on a global campaign to shows how everyone is welcome within the Olympic Movement. Focusing on diversity and inclusion, the “I Belong Here” campaign aimed to inspire a new generation with the belief that, no matter who they are or where they come from, they can find their place in the Olympic community. A central landing page on the Tokyo 2020 website featured a range of campaign activations, including My Flag Belongs Here, which gave people the chance to create their own personalised flag to showcase their unique identity. In addition, the special “I Belong Here” Instagram filter invited everyone to share their story of belonging on their own channels.  296m  media impressions of the I Belong Here campaign"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 87,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg88.jpg",
    "zoom": null,
    "content": "\n      \n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "88  The Visa Award Ahead of Tokyo 2020, the IOC, the IPC and Worldwide Olympic Partner Visa launched a new, fan-voted award to celebrate the most inspiring moments of the Olympic and Paralympic Games.  skateboarder Rayssa Leal receiving the most votes to become the first recipient of The Visa Award.  The Visa Award gave fans the opportunity to vote for their favourite moments of Olympians and Paralympians rising above the competition during the Games, with the new accolade aiming to celebrate friendship, inclusion, acceptance and courage by honouring athletes who best exemplified these values.  The 13-year-old won a silver medal in the women’s street event, but also rose above the competition to lift her rivals’ spirits with acts of kindness, friendship and solidarity. As her prize, Leal’s chosen charity – Social Skate – received a USD 50,000 donation from Visa to support their efforts to make a positive contribution to the lives of socioeconomically vulnerable children and adolescents in Brazil.  A selection of the most emblematic moments were added to the FanZone app and website for fan voting. For the Olympic Games, eight nominees then advanced to the final, with Brazilian  New Zealand's Holly Robinson won The Visa Award for the Paralympic Games. Robinson, who took home gold in the women’s javelin F46 event, was recognised by fans for going out of her way to thank  244,378 votes across during the Olympic Games  match officials and including them in her victory celebration. Her chosen charity, Ronald McDonald House, also received a USD 50,000 donation from Visa."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 88,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg89.jpg",
    "zoom": null,
    "content": "\n      <a target=\"_blank\" href=\"https://olympics.com/en/video/olympic-virtual-series-highlights-week-1')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:358px;top:603px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      <a target=\"_blank\" href=\"https://olympics.com/en/video/olympic-virtual-series-highlights-week-2')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:45px;top:826px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n      <div class=\"addContentLink\" style=\"top:757px;left:488px;width:71px;height:12px\">\n        <a href=\"https://olympics.com/en/original-series/you-got-this/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:794px;left:540px;width:39px;height:12px\">\n        <a href=\"https://olympics.com/en/original-series/unleash-the-new/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:806px;left:460px;width:41px;height:12px\">\n        <a href=\"https://olympics.com/en/original-series/unleash-the-new/\" target=\"_blank\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Fan Engagement  89  Olympic Virtual Series In April 2021, the IOC partnered with five International Sports Federations (IFs) and game publishers to launch the Olympic Virtual Series (OVS) – the first-ever, Olympic-licensed event for physical and non-physical virtual sports. Taking place ahead of the Olympic Games Tokyo 2020, from 13 May to 23 June 2021, the OVS aimed to mobilise virtual sport, esports and gaming enthusiasts all around the world to reach new Olympic audiences, while also encouraging  the development of physical and non-physical forms of sports in line with the recommendations of Olympic Agenda 2020+5. The mass-participation series allowed participants around the world to compete from home or their training facilities in order to generate excitement in the build-up to the Olympic Games Tokyo 2020, with fans able to follow the action on Olympics.com.  “The Olympic Virtual Series is a new, unique Olympic digital experience that aims to grow direct engagement with new audiences in the field of virtual sports.” Thomas Bach, IOC President  TOP co-creations help engage fans around the world The IOC worked with several Worldwide Olympic (TOP) Partners to co-create engagement initiatives around the Olympic Games Tokyo 2020, which helped drive excitement among fans throughout the world. These included: • Working with Samsung on the World Lens – a live augmented reality (AR) camera filter that was designed to showcase the multicultural nature of the Olympic Games. • Collaborating with P&G on a documentary-style film series entitled Good is Gold, which tells the moving, real-life stories of four Olympic and Paralympic athletes and hopefuls as they take action against bias and inequality. • Working with Bridgestone on the Olympic Channel series Olympic State of Body, which takes a scientific look at the top athletes and how they worked on getting to the top. • Collaborating with Toyota on the Olympic Channel series YOU GOT THIS!, which highlights what goes through an athlete’s mind right before they compete, and Unleash The New, which shares the inspiring personal stories of five athletes preparing to compete in the five sports that were added to the Games programme for Tokyo 2020."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 89,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg90.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "90  Olympic Agora Featuring a series of art installations, exhibitions and digital programmes celebrating Olympism, the first-ever Olympic Agora commemorated the cultural aspect of the Olympic Games during Tokyo 2020. The programme featured a sculpture by French artist Xavier Veilhan, a photography installation by Japanese artist Rinko Kawauchi and multimedia installations by Japanese artist Makoto Tojiki and Canadian studio Moment Factory.  Over the course of its six-week opening, the Olympic Agora welcomed thousands of local visitors – giving many unable to attend the Games’ sports competitions an opportunity to engage directly with Olympic culture – and even larger regional and international audiences via its digital programmes, which included virtual exhibitions available on the Olympic Agora website and The Olympic Museum’s social media channels for local and global audiences.  40%  growth in Olympic Museum social media followers due to the Agora  The Agora also showcased a series of new artworks by Olympian and Paralympian Artists-in-Residence, as well as an exhibition of treasures from the permanent holdings of The Olympic Museum. The Olympic Agora, which was on view in the heart of the host city from 1 July to 15 August, was adapted at the outset to ensure staff and visitor safety, in compliance with local and national COVID-19 rules and countermeasures. On-site visitor numbers were strictly controlled through an online pre-booking system.  “One of the most important things we have done through the Olympic Agora is to leave the legacy of the Olympic spirit in Tokyo.” 	Angelita Teo, Director of the Olympic Foundation for Culture and Heritage  6.2m  social media interactions with Olympic Agora content"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 90,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg91.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:200px;left:44px;width:364px;height:42px\">\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/Ie_IkQtZyK4')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Fan Engagement  91  Tomorrow’s Leaves As part of the cultural programme for Tokyo 2020, the Olympic Foundation for Culture and Heritage commissioned Japanese animation company Studio Ponoc to produce “Tomorrow’s Leaves” – a short film inspired by the Olympic values. The special project aimed to celebrate the Olympic spirit, engage a broader international audience, and reinforce the links between sport, culture and education that are fundamental to the Olympic Movement. Produced by the Academy Awardnominated Yoshiaki Nishimura, the hand-drawn animation, which carries a meaningful message about solidarity, collaboration and the environment, received its world premiere at the Annecy International Animated Film Festival in June. In addition to limited theatrical releases worldwide, special screenings also took place in Tokyo during the Olympic Games, including at the Tokyo Skytree and the United Cinema in Toyosu.  “This film is an important work of art that will inspire future generations.” Angelita Teo, Director of the Olympic Foundation for Culture and Heritage"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 91,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg92.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Licensing and Merchandise"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 92,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg93.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 93,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg94.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "94  The Tokyo 2020 Licensing Programme featured a range of almost 8,000 different products  Licensing and Merchandise While supporters were unable to attend the Olympic Games Tokyo 2020 in person, the extensive licensing programme that was launched by the Tokyo 2020 Organising Committee ensured that fans were still able to feel part of the Olympic experience through a vast selection of official products and souvenirs. From clothing, homewares and stationery to plush toys, commemorative pins and traditional crafts, a total of more than 7,994 different items were available to purchase, with the huge range of products catering to all tastes and budgets. Games merchandise was available through the official online store to those residing in  Japan, as well as at 67 retail outlets across the country, including at Tokyo’s two main international airports. Through agreements with 127 official licensees, the Tokyo 2020 licensing programme helped generate vital revenue to support the staging of the Olympic Games, with the products also playing a key role in promoting the event and showcasing the unique identity of the host city. The best selling product was a commemorative pin featuring the emblem for the Olympic Games Tokyo 2020, which sold 300,000 units in total.  “Once the Games had begun, people flocked to Tokyo 2020 Official Shops in the cities and to the online store. Athletes lined up at the official shop in the Olympic and Paralympic Village every day looking for Japanese souvenirs. A rich assortment of nearly 8,000 high-quality products and other goods was available for them to choose from. These also provided an opportunity for athletes from Japan and all over the world, and all the people who supported the Olympic Games, to connect and engage with each other. We believe that these products will help people to relive their memories of Tokyo 2020 in the years to come. We also see Tokyo 2020 official licensed products as more than just souvenirs or banners to wave at events; they reaffirm for everyone involved in the Tokyo 2020 Games that they lived through them.” Aida Norihiko, Tokyo 2020 Head of Licensing"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 94,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg95.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Licensing and Merchandise  95  Tokyo 2020 Licensing Programme 7,994  different products available  56.4m  127  commemorative Olympic coins issued  official licensees  4.2m  67  commemorative Olympic stamps issued  Official Shops during Games-time  300,000  Tokyo 2020 emblem pins sold  Other key collections included: The Traditional Craft Collection, showcasing traditional Japanese techniques and culture in a range of high-quality products representing all 47 prefectures of Japan.  The Art Poster Collection, consisting of 20 official art posters created by 19 artists in a variety of mediums, with the designs featuring on a range of products including postcards, T-shirts, tote bags, calendars and stickers.  The Japanese Olympic Team Collection, including Asics sportswear and a wide selection of accessories for fans wanting to show their support of Japan’s athletes.  Commemorative coins, featuring a total of 37 designs, issued in four series from 2018 to 2020, and comprising 25 Olympic Games coins and 12 Paralympic Games coins.  The Mascot Collection, featuring plush toys, pins, Asics clothing and accessories, and an array of other products showcasing the official Games mascots.  Commemorative stamps, continuing an Olympic tradition that began in 1896, and featuring a total of 75 designs, including 50 stamps representing Olympic events, 23 stamps representing Paralympic events and two logo stamps. Special edition medallist stamps were also made available during the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 95,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg96.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:540px;left:217px;width:386px;height:224px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/N-3d7qYKcD0')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic pins go digital In the build-up to the Olympic Games Tokyo 2020, the IOC and nWay, a subsidiary of Animoca Brands, announced the launch of a new Olympic-themed digital entertainment experience consisting of non-fungible token (NFT) Olympic pins, offering digital versions of collectible and tradeable Olympic pins, and crossplay multiplayer video games. Being NFTs, the Olympic digital pins boast properties generally associated with physical pins, including authenticity, scarcity and provenance, making them true collectors’ items. The NFT Olympic digital pins launched with an inaugural set that forms part of the Olympic Heritage Collection, celebrating the art and design of past Olympic Games and reflecting the graphic legacy of the world’s largest sporting event. Lacoste launched a line of clothing and accessories that celebrated the Olympic Games Tokyo 1964  IOC Global Collections for Tokyo 2020 Guided by its Global Licensing Strategy, the IOC worked with its official licensees around the world to create a wide range of products in celebration of the Olympic Games Tokyo 2020. These included: • The first Olympic Games toy collection, developed with Mattel in collaboration with the Tokyo 2020 Organising Committee, featuring a variety of unique products across Barbie®, Hot Wheels® and UNO®. • A line of clothing and accessories by Lacoste that celebrated the Olympic Games Tokyo 1964, as part of the Olympic Heritage Collection, including a polo shirt, T-shirt, hooded jacket, sweatshirt and cap, inspired by the iconic Tokyo 1964 emblem.  Olympic Games Tokyo 2020 - The Official Video Game featured 18 arcade-style Olympic events  • Mario & Sonic at the Olympic Games Tokyo 2020, a video game developed by SEGA that saw the two iconic characters take gamers on an adventure across more than 30 action-packed Olympic events, which was available exclusively on the Nintendo Switch.  • Sonic at the Olympic Games Tokyo 2020 – a mobile game for iOS and Android that featured 15 Olympic events and allowed players to challenge friends and other gamers around the world."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 96,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg97.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Licensing and Merchandise  97  IOC Global Licensing Programme The IOC Global Licensing Strategy aims to strengthen and promote the Olympic brand, not only during the Olympic Games, but between Games as well. Through official merchandising programmes that are aligned with the Olympic image, its objective is to create a tangible connection to the Olympic Games and Olympism.  The Olympic Collection • Aims to engage young people and to connect with a large audience • Features authentic, high-quality products • Focused mainly on sports equipment and toys • Communicates the essence of the Olympic brand and values to sports fans  The Olympic Heritage Collection  The Olympic Games Programme  • Aims to celebrate the art and design of the past Olympic Games  • Mainly developed and managed by Organising Committees in the host country, offering fans souvenirs of their Games experience  • Features a series of lifestyle and high-end products • Released in limited editions • Allow anyone to own a piece of Olympic history  • IOC aims to drive and create a long-term strategy for international promotion and distribution of Olympic Games merchandise through the Olympic Shop (shop.olympics.com)  • Olympic Games Tokyo 2020 - The Official Video Game, featuring 18 arcade-style Olympic events, an Avatar Creator, eight-player online play, and rich customisation including over 50 costumes, offering aspiring Olympians of all ages the chance to live out their Olympic dreams at-home. It was available on Nintendo Switch, PlayStation 4, Xbox One, Steam and Google Stadia. The game was also fully playable on PlayStation 5 and Xbox Series X and S. • Konami launched a Tokyo 2020 mode in three of their existing sports video games: Power Pro Baseball, Pro Baseball Spirits and Winning Eleven/ Pro Evolution Soccer. The games were available across multiple platforms. • A “Sport for Peace” stamp collection was launched in partnership with the United Nations Postal Administration (UNPA) during the Olympic Games Tokyo 2020 to commemorate the shared values of the two organisations and to highlight sport’s contribution to peace around the world.  The first ever Olympic Games toy collection was developed with Mattel and included a range of Barbie dolls  • Official Gilbert Tokyo 2020 replica rugby balls, field hockey sticks and accessories, developed by Grays International. • The “2020 Lucky Cat Edition”, produced with WAGTI as part of the Olympic Heritage Collection, featuring 30 traditional Japanese ceramic cat figurines with unique artworks depicting iconic moments of past Olympic Games.  “These products will help people to relive their memories of Tokyo 2020 in the years to come.” Betty Aldini, Head of Licensing, e-Commerce & Merchandising, IOC"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 97,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg98.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The Olympic brand"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 98,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg99.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 99,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg100.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "100  The Olympic rings are one of the most widely recognised symbols in the world  The Olympic Rings The Olympic rings floating in Odaiba Marine Park – set against a backdrop of the Rainbow Bridge, Tokyo Tower and the rest of the host city’s impressive skyline – provided one of the most iconic photo opportunities of the Olympic Games Tokyo 2020. Similarly, no athlete’s stay in Tokyo was complete without posing for an Instagramworthy selfie in front of the Olympic Village’s own set of rings to celebrate their participation in the Games and the realisation of their Olympic dreams. Very few symbols have this kind of appeal. But the Olympic rings boast a unique, powerful, and timeless identity that transcends sport. First seen at an Olympic Games in 1920 and based on a design created by Pierre de Coubertin in 1913, the rings are now one of the most widely recognised symbols in the world, with independent research commissioned by the IOC revealing that nine out of 10 people globally are able to correctly identify this iconic emblem.  Seen by billions of people during each edition of the Olympic Games and spread throughout the world as the official symbol of the Olympic Movement, the widespread recognition of the Olympic rings can also be attributed to their unique symbolism. As the visual expression of Olympism, which aims to demonstrate how sport can contribute to building a better world, the rings also represent the union of the five continents and the meeting of athletes from throughout the world at the Olympic Games. The rings therefore embody positive, universal values that make them far more than a logo, and form the cornerstone of the Olympic brand, with each edition of the Olympic Games acting as a celebration of Olympism and a stage for the expression of this powerful and impactful brand.  “I felt so many emotions when I entered the stadium and saw the Olympic rings.” Marcell Jacobs (Italy, athletics)  The appeal of the Olympic brand According to independent consumer research conducted on behalf of the IOC following Tokyo 2020, the Olympic Games remain the most appealing sports and entertainment property in the world. The study also highlighted that the Olympic Games are perceived overall as a “force for good” as, for a majority of respondents, the event is socially responsible and managed in a sustainable way. And the Olympic rings outperformed other globally recognised symbols across a range of values, including “Global”, “Diversity”, “Inspirational”, “Optimistic” and “Inclusive”, as well as the Olympic values of “Excellence” and “Friendship”."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 100,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg101.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/v5GcJWnC_xM')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:26px;top:38px\" src=\"/tokyo2020/static/_content/black-play.png\">\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  The Olympic Brand  101  The Olympic Symbol  First shown on an Olympic flag in 1914  Designed by Baron Pierre de Coubertin in 1913  Visual representation of Olympism  Can be identified by 9 out of 10 people globally  Interlinked rings show how athletes come together at the Games  Represent the five continents of the world  Tokyo’s floating Olympic rings stretched 33m wide and 15m high"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 101,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg102.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/-0Avu_a6drE')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:567px;top:368px\" src=\"/tokyo2020/static/_content/gold-play.png\">\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "102  Tokyo 2020 Visual Identity While the Olympic rings have been a constant presence at each Games since 1920, providing a symbolic continuity from one edition to the next, each Olympic Games also features its own distinctive identity that provides an eye-catching backdrop to the sporting action and adds to the visual spectacle of the Games. This ‘Look of the Games’ can be seen throughout the host city and the Olympic venues during the Games and is often inspired by the culture, character and history of the host city and country, and by the Organising Committee’s vision for the Games.  The Look of the Games for Tokyo 2020 was inspired by the three types of rectangular shapes that form the Tokyo 2020 emblem and the Japanese colour layering technique known as kasane no irome, which was used for kimonos during the Heian Period (794-1185). The colour scheme used four traditional Japanese colours: • Kurenai (red): a symbolic colour of Japan, often used during celebrations • Ai (blue): widely familiar as a colour representing Japan and also the colour of the Tokyo 2020 emblems  Each Games features a unique visual identity that provides an eye-catching backdrop to the sporting action  • Fuji (purple): the colour of the Japanese wisteria, a popular native flower • Matsuba (green): the colour of pine needles, commonly used in celebrations.  “Every single time I see the Olympic rings, my heart is so full, and I’m so proud to be here.” Eilidh McIntyre (Great Britain, sailing)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 102,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg103.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:242px;left:64px;width:38px;height:11px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/MmdtZMi4mQ0')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:616px;left:94px;width:62px;height:11px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/4t_7P9LShqU')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:194px;left:314px;width:38px;height:11px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/ZCxiPW-QMRY')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:469px;left:244px;width:183px;height:126px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/W5Vbqq3UQDo')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:616px;left:287px;width:52px;height:11px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/W5Vbqq3UQDo')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:52px;left:442px;width:182px;height:122px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/QJG6duYxpMY')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:194px;left:460px;width:73px;height:11px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/uOo_gFjECIQ')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:444px;left:442px;width:182px;height:126px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/WpKHAO07vJs')\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:591px;left:461px;width:64px;height:11px\">\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/WdLlDRVhlVE')\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  The Olympic Brand  103  There were several other key elements to the Tokyo 2020 visual identity:  The emblem, unveiled in April 2016, was inspired by a chequered pattern known as ichimatsu moyo from the Edo period (1603-1867), and uses the traditional Japanese colour of indigo blue, which expresses a refined elegance and sophistication. Composed of three varieties of rectangular shapes, the design represents different countries, cultures and ways of thinking and incorporates the Games vision of “Unity in Diversity.” It also expresses the fact that the Olympic Games seek to promote diversity as a platform to connect the world. The emblem was designed by Asao Tokolo and selected following an open competition, which attracted a total of 14,599 entrants from all over the world.  The official Games motto was revealed in February 2020. “United By Emotion” encapsulated Tokyo 2020’s vision for the Games and aimed to emphasise the power of sport to bring together people from diverse backgrounds and allow them to connect and celebrate in a way that reaches beyond their differences.  The Tokyo 2020 mascots were unveiled in February 2018 after elementary school pupils across Japan and at Japanese schools overseas chose their favourites from a shortlist of three sets of designs. The winning designs were created by graphic designer Ryo Taniguchi whose characters – dark blue for Miraitowa, the Olympic Games mascot, and cherry blossom pink for Someity, the Paralympic Games mascot – strove to combine traditional values with futuristic looks, encapsulating the “innovation from harmony” concept that is at the heart of the branding vision for Tokyo 2020. Miraitowa is a combination of the Japanese words mirai, which means future, and towa which means eternity. Someity is a hybrid of the words someiyoshino - a type of cherry blossom - and the English phrase, ‘so mighty’.  The sport pictograms, representing the 50 disciplines across all 33 Olympic sports, were unveiled in March 2019. The design was inspired by the first ever Olympic pictograms, which were introduced when Tokyo last hosted the Olympic Games in 1964 as a way to visually communicate information to athletes and spectators from around the world. The Tokyo 2020 pictograms were designed to subtly communicate the characteristics and athleticism of each sport. For the first time in Olympic history, kinetic pictograms were also introduced – further honouring the legacy of 1964 and highlighting the innovation at the centre of Tokyo 2020. The kinetic pictograms appeared as a series of three movements: appear, static, and disappear. These recreated the three-dimensional movements of athletes in two dimensions, and were able to better express dynamic movements such as twists.  The Olympic medals were unveiled in July 2019, featuring a design that resembled a rough stone that has been polished to shine with ‘light’ and ‘brilliance’, reflecting the efforts of athletes who strive for victory. Through a landmark recycling initiative, each medal was moulded entirely from metal extracted from recycled consumer electronics that were collected through a nationwide project that engaged the Japanese public. A total of 78,985 tons of discarded devices were collected – a haul which included approximately 6.21 million used mobile phones, along with digital cameras, handheld games and laptops, all of which were then classified, dismantled and melted down to make the medals.  The Olympic Torch was unveiled in March 2019, featuring a motif of a cherry blossom – a flower close to the hearts of all Japanese people. The shape of the torch resembled that of a Japanese traditional Sakura-mon, the cherry blossom crest, and it was constructed using aluminium construction waste from temporary housing built in the aftermath of the 2011 Great East Japan Earthquake."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 103,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg104.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "104  Preserving the Commercial Value of the Olympic Brand The IOC’s marketing programmes are built on its ability to offer its commercial partners an exclusive association with the Olympic symbol – one of the most universally recognised brands in the world. Any attempt to use the Olympic symbol or other Olympic properties1 without permission – known as ambush marketing2 – can negatively affect the integrity of this brand. This directly impacts the Olympic marketing programmes, diminishing their ability to generate revenue that is redistributed by the IOC to support athletes and sports organisations at all levels around the world. The IOC and its partners in the Olympic Movement therefore take the threat of ambush marketing very seriously. Its aim is to protect the integrity of the Olympic  properties (including the Olympic symbol), the Olympic Games, and the investment of its official partners. Without the revenue and support of Olympic broadcasters and marketing partners, the Olympic Games would simply not happen. The IOC works on a market-bymarket basis with the National Olympic Committees and Organising Committee before each Games to educate each market and companies about who the official partners are and why ambush marketing is detrimental to the Olympic Games. The IOC reviews each infringement individually, taking into consideration the circumstances of each case, such as the market, the scope of the infringement and the infringer, before taking expedient action.  The Olympic Games maintains a clean venue policy, guaranteeing that the main focus is on athletes and sport  “Our marketing partners are the pillars on which the Olympic Movement is funded and we therefore need to ensure that their exclusive commercial rights are protected.” Timo Lumme, Managing Director, IOC Television and Marketing Services 1 Olympic properties (as defined by the Olympic Charter) include without limitation the Olympic symbol, flag, motto, anthem, identifications (including but not limited to “Olympic Games” and “Games of the Olympiad”), designations, emblems, mascots, flame, torches, images and/or terminology, and any and all rights derived from the Olympic Games and/or the Youth Olympic Games. 2 Direct and/or indirect unauthorised association with, exploitation or promotion of, the Olympic properties and/or the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 104,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg105.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 105,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg106.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "106  Tokyo 2020 Brand Protection Programme During Tokyo’s bid to host the 2020 Olympic and Paralympic Games, the national government of Japan pledged to the IOC that it would abide by the Olympic Charter and protect all Olympic-related intellectual properties. All intellectual properties including emblems, logos and designations relating to the Olympic and Paralympic Games, were therefore legally protected in Japan by the Trademark Law, the Unfair Competition Prevention Law and the Copyright Law. Use of these intellectual properties for the Olympic Games Tokyo 2020 were managed by the Tokyo 2020 Organising Committee, which initiated the following measures:  Ambush Marketing Prevention The key focus for Tokyo 2020 was “Preventive action in advance”. The Organising Committee therefore conducted more than 100 educational seminars and anti-ambush campaigns with stakeholders in the lead-up to the Games. Appropriate measures against ambush marketing were then conducted with the support from the Games legal department, the IOC, the Japanese Olympic Committee and local authorities both before and during the Games.  Clean Venue Operation Each edition of the Olympic Games maintains a clean venue policy that prevents any commercial, political or religious advertising at Games venues, guaranteeing that the main focus is on athletes and sport. Tokyo 2020 hired contractors to ensure this policy was adhered to within all venues and submitted a comprehensive clean venue report to the IOC in advance of the Games. In addition, clean venue inspection tours were conducted together with the IOC.  Outdoor Advertising Programme Tokyo 2020 worked with an advertising agency to control and manage the outdoor advertising inventories around the Olympic venues and other key sites in order to provide priority purchasing opportunities to the Olympic partners and therefore prevent ambush marketing attempts. Brand usage approvals Tokyo 2020, with cooperation from the IOC, arranged license agreements with non-commercial entities – such as the host city, host government and host venue cities – for the usage of intellectual property of Tokyo 2020. For every usage, an approvals process was undertaken based on the regulations outlined in usage guidelines."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 106,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg107.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  The Olympic Brand  107  The IOC monitors global broadcast coverage of each Games to identify any infringements upon the rights of the official Olympic broadcasting partners  Global Broadcast and Internet Monitoring The IOC monitors the global broadcast coverage of each Olympic Games to identify illegal streaming of audio-visual content and any unauthorised use of audio-visual content, which infringes upon the rights of the official Olympic broadcast partners. The primary purpose of the Internet Monitoring Programme (IMP) is to protect the exclusive rights awarded by the IOC to its broadcast partners, in different territories, from the threats posed by unauthorised online video material with a particular focus on live streaming activity. For Tokyo 2020, the IMP used the most advanced technologies available to prevent, track and take appropriate action against violations, such as video infringements on any online or mobile platform.  For Tokyo 2020, the IOC used the most advanced technologies available to monitor broadcast and internet coverage  In addition, the IMP also included the monitoring of mechanisms implemented by broadcasters to restrict access only to viewers in their licensed territories, commonly referred to as “geo-blocking”, as well as the security of the Games content delivery via their platforms.  The IOC worked with its rights-holding media partners – as well as major technology companies, including social media platforms – to ensure the timely removal of infringing content, with the biggest deterrent against piracy being the promotion of the official, highquality broadcast coverage of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 107,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg108.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/o7Pr_BFxrq8')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:575px;top:88px\" src=\"/tokyo2020/static/_content/white-play.png\">\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "ACKNOWLEDGEMENTS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 108,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg109.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 109,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg110.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/8N2QSM_s3Zo')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:555px;top:33px\" src=\"/tokyo2020/static/_content/white-play.png\">\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "“Our warm thanks go to our Worldwide Olympic Partners and Rights-Holding Broadcasters for their truly outstanding show of unity and support. Without them, these Olympic Games would not have been possible, the athletes would not have had their moment to shine and the world would not have been united by the emotion of Tokyo 2020.” Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 110,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg111.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Acknowledgements  111  Olympic Broadcast Partners • ABU  • Grupo Globo  • Supersport  • Albavision-Televideo  • ICRT  • TSG  • America Movil  • International Media Content  • IMG  • BBC  • Infront  • Televisa  • beIN  • Japan Consortium  • TV Publica  • Caracol  • NBCUniversal  • TVN Chile  • CBC  • SABC  • CCTV  • SBS  • Dentsu  • Seven Network  • Discovery  • Sky Network  • France Televisions  • Sony  Worldwide Olympic Partners  Tokyo 2020 Gold Partners"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 111,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg112.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "112  Tokyo 2020 Official Partners • Ajinomoto  • DNP  • Japan Airlines Co., Ltd.  • Earth Chemical Co., Ltd  • Daiwa House Industry Co., Ltd.  • East Japan Railway Company  • EF Education First Japan Ltd.  • Tokyo Gas  • Hisamitsu Pharmaceutical Co.,Inc.  • Air Weave  • Tokyo Metro Co., Ltd.  • Mitsubishi Electric  • Kikkoman  • Toto  • Yamato Holdings  • KNT-CT Holdings  • Tobu Top Tours  • Recruit Holdings  • JTB  • Toppan  • Yomiuri Shimbun  • Cisco Systems G.K.  • Narita International Airport Corporation  • Asahi Shimbun  • Secom  • Nissin Foods Holdings Co., Ltd.  • Nikkei Shimbun  • Ana  • Japan Post Holdings  • Mainichi Shimbun  • Alsok  • Japan Airport Terminal Co., Ltd."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 112,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg113.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Tokyo 2020  Acknowledgements  113  Tokyo 2020 Official Supporters • Aoki  • Shimizu Corporation  • BCG Japan  • Aggreko  • Tanaka Holdings  • Marudai Food  • ECC  • Technogym  • Morisawa  • EY Japan  • TOBU TOWER SKYTREE  • Yahoo Japan Corporation  • Kadokawa  • Nomura Co., Ltd.  • The Sankei Shinbun  • Google  • Park24  • The Hokkaido Shinbun Press  • Kokuyo  • Pasona Group"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 113,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg114.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "114  EDITORIAL, DESIGN AND PRODUCTION IOC Touchline  PHOTOGRAPHY IOC Images Tokyo 2020 Getty Images  RESEARCH  Publicis Sport & Entertainment International Olympic Committee Maison Olympique, 1007 Lausanne, Switzerland Tel: +41 (0) 21 621 6111 www.olympics.com/ioc © This publication may not be reproduced, even in part, in any form, without the written permission of the IOC. All reproduction, translation and adaptation rights are reserved for all countries."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 114,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg115.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 115,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg116.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "International Olympic Committee  Château De Vidy, 1007 Lausanne, Switzerland www.olympic.org"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-199016370-34',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Q4jA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QRRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R3wh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UR7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WI9Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zhdp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bQQb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "be29":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f34v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNxP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gUQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gkoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m1X4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mp9z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.79de7a6390efd54cacc6.js